// import React, { useEffect, useState, useRef } from 'react';
// import { Link } from 'react-router-dom';
// import 'react-datepicker/dist/react-datepicker.css';
// import { _Api, Api_form } from '../api/_call';
// import TableColumnModal from '../common/modules/tableColumn';
// import { ImportExcelModal } from '../common/modules/importExcel';
// import './diamond.scss';
// import Slider from 'rc-slider';
// import {
//   success,
//   error,
//   loading,
//   Updateloading,
// } from '../common/helpers/toastify';
// import 'rc-slider/assets/index.css';
// import InfiniteScroll from 'react-infinite-scroll-component';
// import DatePicker from 'react-datepicker';
// import { formatDate } from '../common/helpers/formatDate';
// import SocialModal from '../common/modules/SocialModal/SocialModal';
// import { useTranslation } from 'react-i18next';
// import { useSelector } from 'react-redux';
// const DiamondSearch = (props) => {

//   const { t } = useTranslation()
//   const [importfile, setImportfile] = useState()
//   const datePickerRef = useRef(null)
//   const [startdate, setStartdate] = useState()
//   const [enddate, setEnddate] = useState()
//   const [daimondfilter, setDaimondfilters] = useState()
//   const [cut, setCut] = useState([])
//   const [clarity, setClarity] = useState([])
//   const [stonecolor, setStonecolors] = useState([])
//   const [polish, setPolish] = useState([])
//   const [symmetry, setSymmetry] = useState([])
//   const [fluorescence, setFluorescence] = useState([])
//   const [datelable, setDatelable] = useState('Show All')
//   const [lbs, setLbs] = useState([])
//   const [Status, setStatus] = useState([])
//   const [Location, setLocation] = useState([])
//   const [shape, setShape] = useState([])
//   const [comparisiondata, setComparisiondata] = useState('')
//   // const [exportdata, setExportdata] = useState('') // OLD Export modal list
//   const [items, setItems] = useState([])
//   const [totalresult, setTotalresult] = useState(0)
//   const [rowlength, setRowlength] = useState(0)
//   const [listPage, setListPage] = useState(0)
//   const DIAMOND_LIST_LIMIT = 10
//   const [val1, setVal1] = useState([47, 900])
//   const [val2, setVal2] = useState([0.1, 4.0])
//   const [val3, setVal3] = useState([45, 86])
//   const [val4, setVal4] = useState([45, 86])
//   const [FilterSubmitClass, setFilterSubmitClass] = useState('')
//   const [socialurl, setSocialurl] = useState()
//   const [shareloader, setShareloader] = useState(false)
//   const parmissiondatashow = useSelector((state) => state.app.ApplyParmission);
//   const base_assets = process.env.REACT_APP_BASE_ASSETS_URL
//   const readExcel = async () => {
//     const handleValidation = (e) => {
//       let formIsValid = true
//       if (!importfile) {
//         formIsValid = false
//         error(t('Choose file!'))
//       }
//       return formIsValid
//     }
//     if (handleValidation()) {
//       try {
//         const formData = new FormData()
//         formData.append('file', importfile)
//         formData.append('type', 'DiamondImport')
//         let res = await Api_form(
//           formData,
//           `api/v1/Inventory/diamond/uploadDiamondxls`,
//         )
//         if (res.code === 200) {
//           success(
//             t("File Sucessfully Uploaded and Backend Process have  Started Now,Please wait!!")
//           )
//           daimondfilters()
//         } else {
//           error(
//             res?.message ||
//               res?.msg ||
//               res?.errors?.[0]?.msg ||
//               t('Please Wait or try again later!!')
//           )
//         }
//       } catch (err) {
//         console.log(err, 'err')
//       }
//     }
//   }

//   const SampleExcel = async () => {
//     try {
//       const posdata = {}
//       let res = await _Api(posdata, `api/v1/Inventory/diamond/DiamondSamplexls`)
//       if (res.code === 200) {
//         const exportLinkElement = document.createElement('a')

//         exportLinkElement.hidden = true
//         exportLinkElement.download = 'Daimond.xlsx'
//         exportLinkElement.href = res.data
//         exportLinkElement.text = 'downloading...'

//         document.body.appendChild(exportLinkElement)
//         exportLinkElement.click()
//         exportLinkElement.remove()
//       } else {
//       }
//     } catch (err) {
//       console.log(err, 'err')
//     }
//   }

//   const callfilters = (event, label) => {
//     if (label === 'cut') {
//       var elem = document.getElementById('cut' + event.target.id)
//       if (elem.classList.contains('active')) {
//         elem.classList.remove('active')
//         setCut((current) => current.filter((item) => item !== event.target.id))
//       } else {
//         elem.classList.add('active')
//         const cutdata = [...cut]
//         cutdata.push(event.target.id)
//         setCut(cutdata)
//       }
//     }
//     if (label === 'clarity') {
//       let elem = document.getElementById('clarity' + event.target.id)
//       if (elem.classList.contains('active')) {
//         elem.classList.remove('active')
//         setClarity((current) =>
//           current.filter((item) => item !== event.target.id),
//         )
//       } else {
//         elem.classList.add('active')
//         const claritydata = [...clarity]
//         claritydata.push(event.target.id)
//         setClarity(claritydata)
//       }
//     }
//     if (label === 'stonecolor') {
//       let elem = document.getElementById('stonecolor' + event.target.id)
//       if (elem.classList.contains('active')) {
//         elem.classList.remove('active')
//         setStonecolors((current) =>
//           current.filter((item) => item !== event.target.id),
//         )
//       } else {
//         elem.classList.add('active')
//         const stonecolordata = [...stonecolor]
//         stonecolordata.push(event.target.id)
//         setStonecolors(stonecolordata)
//       }
//     }

//     if (label === 'polish') {
//       let elem = document.getElementById('polish' + event.target.id)
//       if (elem.classList.contains('active')) {
//         elem.classList.remove('active')
//         setPolish((current) =>
//           current.filter((item) => item !== event.target.id),
//         )
//       } else {
//         elem.classList.add('active')
//         const polishdata = [...polish]
//         polishdata.push(event.target.id)
//         setPolish(polishdata)
//       }
//     }
//     if (label === 'symmetry') {
//       let elem = document.getElementById('symmetry' + event.target.id)
//       if (elem.classList.contains('active')) {
//         elem.classList.remove('active')
//         setSymmetry((current) =>
//           current.filter((item) => item !== event.target.id),
//         )
//       } else {
//         elem.classList.add('active')
//         const symmetrydata = [...symmetry]
//         symmetrydata.push(event.target.id)
//         setSymmetry(symmetrydata)
//       }
//     }
//     if (label === 'fluorescence') {
//       let elem = document.getElementById('fluorescence' + event.target.id)
//       if (elem.classList.contains('active')) {
//         elem.classList.remove('active')
//         setFluorescence((current) =>
//           current.filter((item) => item !== event.target.id),
//         )
//       } else {
//         elem.classList.add('active')
//         const fluorescencedata = [...fluorescence]
//         fluorescencedata.push(event.target.id)
//         setFluorescence(fluorescencedata)
//       }
//     }
//     if (label === 'lbs') {
//       let elem = document.getElementById('l' + event.target.id)
//       if (elem.classList.contains('active')) {
//         elem.classList.remove('active')
//         setLbs((current) =>
//           current.filter((item) => item !== event.target.value),
//         )
//       } else {
//         elem.classList.add('active')
//         const lbsdata = [...lbs]
//         lbsdata.push(event.target.value)
//         setLbs(lbsdata)
//       }
//     }
//     if (label === 'status') {
//       let elem = document.getElementById('status' + event.target.id)
//       if (elem.classList.contains('active')) {
//         elem.classList.remove('active')
//         setStatus((current) =>
//           current.filter((item) => item !== event.target.value),
//         )
//       } else {
//         elem.classList.add('active')
//         const statusdata = [...Status]
//         statusdata.push(event.target.value)
//         setStatus(statusdata)
//       }
//     }
//     if (label === 'Location') {
//       let elem = document.getElementById('Location' + event.target.id)
//       if (elem.classList.contains('active')) {
//         elem.classList.remove('active')
//         setLocation((current) =>
//           current.filter((item) => item !== event.target.id),
//         )
//       } else {
//         elem.classList.add('active')
//         const locationdata = [...Location]
//         locationdata.push(event.target.id)
//         setLocation(locationdata)
//       }
//     }
//     if (label === 'shape') {
//       const id = event.currentTarget.dataset.id
//       const shapedata = [...shape]
//       let elem = document.getElementById('shape' + id)
//       if (elem.classList.contains('active')) {
//         elem.classList.remove('active')
//         setShape(shapedata.filter((n) => n !== id))
//       } else {
//         elem.classList.add('active')
//         shapedata.push(id)
//         setShape(shapedata)
//       }
//     }
//     setFilterSubmitClass('btn-gliter')
//   }
//   const getsharediamondsearch = async () => {
//     setShareloader(true)

//     try {
//       const postdata = {
//         length: rowlength,
//         limit: 10,
//         skip: rowlength,
//         CUT: cut,
//         Clarity: clarity,
//         Stonecolor: stonecolor,
//         Polish: polish,
//         Symmetry: symmetry,
//         fluorescence: fluorescence,
//         Lbs: lbs,
//         status: Status,
//         Location: Location,
//         Shape: shape,
//         Price: [{ min: val1[0], max: val1[1] }],
//         Carat: [{ min: val2[0], max: val2[1] }],
//         Depth: [{ min: val3[0], max: val3[1] }],
//         Table: [{ min: val4[0], max: val4[1] }],
//       }
//       let res = await _Api(
//         postdata,
//         `api/v1/Inventory/inventory/print/diamondSearch`,
//       )

//       if (res.code === 200) {
//         setSocialurl(res?.link)
//         setShareloader(false)
//       }
//     } catch (err) {
//       console.log(err, 'err')
//     }
//   }
//   const getprintdiamondsearch = async () => {
//     let GetloadingID = loading()
//     try {
//       const postdata = {
//         length: rowlength,
//         limit: 10,
//         skip: rowlength,
//         CUT: cut,
//         Clarity: clarity,
//         Stonecolor: stonecolor,
//         Polish: polish,
//         Symmetry: symmetry,
//         fluorescence: fluorescence,
//         Lbs: lbs,
//         status: Status,
//         Location: Location,
//         Shape: shape,
//         Price: [{ min: val1[0], max: val1[1] }],
//         Carat: [{ min: val2[0], max: val2[1] }],
//         Depth: [{ min: val3[0], max: val3[1] }],
//         Table: [{ min: val4[0], max: val4[1] }],
//       }
//       let res = await _Api(
//         postdata,
//         `api/v1/Inventory/inventory/print/diamondSearch`,
//       )

//       if (res.code === 200) {
//         setTimeout(() => {
//           const exportLinkElement = document.createElement('a')
//           exportLinkElement.hidden = true
//           exportLinkElement.download = res?.name ? res?.name : 'report.pdf'
//           exportLinkElement.href = res?.link
//           exportLinkElement.text = 'downloading...'
//           exportLinkElement.setAttribute('target', '_blank')
//           document.body.appendChild(exportLinkElement)
//           exportLinkElement.click()
//           exportLinkElement.remove()
//           Updateloading(t, GetloadingID, t('download successfully'))
//         }, 50)
//         setSocialurl(res?.link)
//       } else {
//         Updateloading(t, GetloadingID, res?.message ? (res?.message) : (res?.errors), 'error');
//       }
//     } catch (err) {
//       console.log(err, 'err')
//       Updateloading(t, GetloadingID, err, t('error'))
//     }
//   }
//   const submitfilters = async () => {
//     setTotalresult(0)
//     setRowlength(0)
//     setListPage(0)
//     const integerArray = Status.map(Number);
//     try {
//       const posdata = {
//         length: 0,
//         limit: DIAMOND_LIST_LIMIT,
//         skip: 0,
//         CUT: cut,
//         Clarity: clarity,
//         Stonecolor: stonecolor,
//         Polish: polish,
//         Symmetry: symmetry,
//         fluorescence: fluorescence,
//         Lbs: lbs,
//         Status: integerArray,
//         Location: Location,
//         Shape: shape,
//         Price: [{ min: val1[0], max: val1[1] }],
//         Carat: [{ min: val2[0], max: val2[1] }],
//         Depth: [{ min: val3[0], max: val3[1] }],
//         Table: [{ min: val4[0], max: val4[1] }],

//       }

//       let res = await _Api(posdata, `api/v1/Inventory/diamond/getList`)
//       if (res.code === 200) {
//         const rows = res.data || []
//         setItems(rows)
//         setTotalresult(Number(res.totalResult) || 0)
//         setRowlength(DIAMOND_LIST_LIMIT)
//         setListPage(0)
//       }
//     } catch (err) {
//       console.log(err, 'err')
//     }
//     setFilterSubmitClass('')
//   }
//   const changeDates = (lable) => {
//     const MainDate = new Date()
//     if (lable === 'Today') {
//       setStartdate(new Date())
//       setEnddate(new Date())
//       setDatelable('Today')
//     } else if (lable === 'Yesterday') {
//       const yesterdaydate = new Date(MainDate.setDate(MainDate.getDate() - 1))
//       setStartdate(yesterdaydate)
//       setEnddate(yesterdaydate)
//       setDatelable('Yesterday')
//     } else if (lable === '7days') {
//       const sevendays = new Date(MainDate.setDate(MainDate.getDate() - 7))
//       setStartdate(sevendays)
//       setEnddate(new Date())
//       setDatelable('7days')
//     } else if (lable === '30days') {
//       const days = new Date(MainDate.setDate(MainDate.getDate() - 30))
//       setStartdate(days)
//       setEnddate(new Date())
//       setDatelable('30days')
//     } else if (lable === 'ThisMonth') {
//       const firstDay = new Date(MainDate.getFullYear(), MainDate.getMonth(), 1)
//       const lastDay = new Date(
//         MainDate.getFullYear(),
//         MainDate.getMonth() + 1,
//         0,
//       )
//       setStartdate(firstDay)
//       setEnddate(lastDay)
//       setDatelable('ThisMonth')
//     } else if (lable === 'LastMonth') {
//       const firstDay = new Date(MainDate.getFullYear(), MainDate.getMonth() - 1, 1)
//       const lastDay = new Date(MainDate.getFullYear(), MainDate.getMonth(), 0)
//       setStartdate(firstDay)
//       setEnddate(lastDay)
//       setDatelable('LastMonth')
//     }
//   }
//   // Start diamond export â†’ notification bell will have download link when ready
//   const callexportrequest = async () => {
//     try {
//       const posdata = { type: 'DiamondExport' }
//       let res = await _Api(posdata, `api/v1/Inventory/diamond/downloadDiamondxls`)
//       if (res.code === 200) {
//         success(
//           t(
//             res?.message ||
//               'Export started. Download will be available in Notifications.',
//           ),
//         )
//       } else {
//         error(res?.message || t('Please Wait or try again later!!'))
//       }
//     } catch (err) {
//       error(t('Please Wait or try again later!!'))
//       console.log(err, 'err')
//     }
//   }
//   // OLD: Export history popup list (modal) â€” kept for reference
//   // const callexportlist = async () => {
//   //   try {
//   //     const posdata = { type: 'DiamondExport' }
//   //     let res = await _Api(posdata, `api/v1/Inventory/diamond/getExportList`)
//   //     if (res.code === 200) {
//   //       setExportdata(res.data)
//   //       success(t(res?.message))
//   //     } else {
//   //       error(res?.errors)
//   //     }
//   //   } catch (err) {
//   //     console.log(err, 'err')
//   //   }
//   // }
//   const daimondfilters = async (lable) => {
//     try {
//       const posdata = {}
//       let res = await _Api(posdata, `api/v1/Inventory/diamond/getFilters`)
//       if (res.code === 200) {
//         let shapes = [],
//           colors = [],
//           cuts = [],
//           polishs = [],
//           claritys = [],
//           symmetrys = [],
//           fluorescences = [],
//           lbss = [],
//           status = [],
//           locations = [],
//           Price = [],
//           Carat = [],
//           Depth = [],
//           Table = []
//         setCut([])
//         setShape([])
//         setStonecolors([])
//         setClarity([])
//         setPolish([])
//         setSymmetry([])
//         setFluorescence([])
//         setLbs([])
//         setStatus([])
//         setLocation([])
//         setDaimondfilters(res.data)
//         if (res.data?.Shape) {
//           res.data?.Shape.forEach((result) => {
//             setShape((shape) => shape.concat(result?._id))
//             shapes.push(result?._id)
//           })
//         }
//         if (res.data?.StoneColor) {
//           res.data?.StoneColor.forEach((result) => {
//             setStonecolors((stonecolor) => stonecolor.concat(result?._id))
//             colors.push(result?._id)
//           })
//         }
//         if (res.data?.Clarity) {
//           res.data?.Clarity.forEach((result) => {
//             setClarity((clarity) => clarity.concat(result?._id))
//             claritys.push(result?._id)
//           })
//         }
//         if (res.data?.Cut) {
//           res.data?.Cut.forEach((result) => {
//             setCut((cut) => cut.concat(result?._id))
//             cuts.push(result?._id)
//           })
//         }
//         if (res.data?.Polish) {
//           res.data?.Polish.forEach((result) => {
//             setPolish((polish) => polish.concat(result?._id))
//             polishs.push(result?._id)
//           })
//         }
//         if (res.data?.Symmetry) {
//           res.data?.Symmetry.forEach((result) => {
//             setSymmetry((symmetry) => symmetry.concat(result?._id))
//             symmetrys.push(result?._id)
//           })
//         }
//         if (res.data?.Fluorescence) {
//           res.data?.Fluorescence.forEach((result) => {
//             setFluorescence((fluorescence) =>
//               fluorescence.concat(result?._id),
//             )
//             fluorescences.push(result?._id)
//           })
//         }
//         if (res.data?.Lbs) {
//           res.data?.Lbs.forEach((result) => {
//             setLbs((lbs) => lbs.concat(result))
//             lbss.push(result)
//           })
//         }
//         if (res.data?.Status) {
//           res.data?.Status.forEach((result) => {
//             setStatus((status) => status.concat(result))
//             status.push(result)
//           })
//         }
//         if (res.data?.Location) {
//           res.data?.Location.forEach((result) => {
//             setLocation((location) => location.concat(result?._id))
//             locations.push(result?._id)
//           })
//         }
//         setVal1([res.data?.Price?.min, res.data?.Price?.max])
//         setVal2([res.data?.Carat?.min, res.data?.Carat?.max])
//         setVal3([res.data?.Depth?.min, res.data?.Depth?.max])
//         setVal4([res.data?.Table?.min, res.data?.Table?.max])
//         Price.push({ min: res.data?.Price?.min, max: res.data?.Price?.max })
//         Carat.push({ min: res.data?.Carat?.min, max: res.data?.Carat?.max })
//         Depth.push({ min: res.data?.Depth?.min, max: res.data?.Depth?.max })
//         Table.push({ min: res.data?.Table?.min, max: res.data?.Table?.max })
//         if (lable === 'reset') {
//           const reshape = document.querySelectorAll('.resetshape')
//           for (const x of reshape) {
//             x.classList.add('active')
//           }
//           const recolor = document.querySelectorAll('.resetcolor')
//           for (const x of recolor) {
//             x.classList.add('active')
//           }
//           const reclarity = document.querySelectorAll('.resetclarity')
//           for (const x of reclarity) {
//             x.classList.add('active')
//           }
//           const recut = document.querySelectorAll('.resetcut')
//           for (const x of recut) {
//             x.classList.add('active')
//           }
//           const repolish = document.querySelectorAll('.resetpolish')
//           for (const x of repolish) {
//             x.classList.add('active')
//           }
//           const resymmetry = document.querySelectorAll('.resetsymmetry')
//           for (const x of resymmetry) {
//             x.classList.add('active')
//           }
//           const refluorescence = document.querySelectorAll('.resetfluorescence')
//           for (const x of refluorescence) {
//             x.classList.add('active')
//           }
//           const relab = document.querySelectorAll('.resetlab')
//           for (const x of relab) {
//             x.classList.add('active')
//           }
//           const restatus = document.querySelectorAll('.resetstatus')
//           for (const x of restatus) {
//             x.classList.add('active')
//           }
//           const relocation = document.querySelectorAll('.resetLocation')
//           for (const x of relocation) {
//             x.classList.add('active')
//           }
//           setRowlength(0)
//           setListPage(0)
//           setFilterSubmitClass('')
//         }
//         setTimeout(async () => {
//           try {
//             const posdata = {
//               length: 0,
//               limit: DIAMOND_LIST_LIMIT,
//               skip: 0,
//               CUT: cuts,
//               Clarity: claritys,
//               Stonecolor: colors,
//               Polish: polishs,
//               Symmetry: symmetrys,
//               fluorescence: fluorescences,
//               Lbs: lbss,
//               Status: status,
//               Location: locations,
//               Shape: shapes,
//               Price: Price,
//               Carat: Carat,
//               Depth: Depth,
//               Table: Table,
//               start_date: startdate ? startdate : new Date(),
//               end_date: enddate ? enddate : new Date(),
//             }
//             let res = await _Api(posdata, `api/v1/Inventory/diamond/getList`)
//             if (res.code === 200) {
//               const rows = res.data || []
//               setItems(rows)
//               setTotalresult(Number(res.totalResult) || 0)
//               setRowlength(DIAMOND_LIST_LIMIT)
//               setListPage(0)
//               setDatelable('Show All')
//             }
//           } catch (err) {
//             console.log(err, 'err')
//           }
//         }, 1000)
//       }
//     } catch (err) {
//       console.log(err, 'err')
//     }
//   }
//   const fetchMoreData = () => {
//     const loaded = (listPage + 1) * DIAMOND_LIST_LIMIT
//     if (!totalresult || loaded >= totalresult) {
//       return
//     }
//     const nextPage = listPage + 1
//     const nextSkip = nextPage * DIAMOND_LIST_LIMIT
//     const integerArray = Status.map(Number);
//     setTimeout(async () => {
//       try {
//         const posdata = {
//           length: nextSkip,
//           limit: DIAMOND_LIST_LIMIT,
//           skip: nextSkip,
//           CUT: cut,
//           Clarity: clarity,
//           Stonecolor: stonecolor,
//           Polish: polish,
//           Symmetry: symmetry,
//           fluorescence: fluorescence,
//           Lbs: lbs,
//           Status: integerArray,
//           Location: Location,
//           Shape: shape,
//           Price: [{ min: val1[0], max: val1[1] }],
//           Carat: [{ min: val2[0], max: val2[1] }],
//           Depth: [{ min: val3[0], max: val3[1] }],
//           Table: [{ min: val4[0], max: val4[1] }],
//         }
//         let res = await _Api(posdata, `api/v1/Inventory/diamond/getList`)
//         if (res.code === 200) {
//           const rows = res.data || []
//           if (!rows.length) {
//             setRowlength(totalresult)
//             setListPage(nextPage)
//             return
//           }
//           setItems((prev) => (prev || []).concat(rows))
//           setListPage(nextPage)
//           setRowlength((nextPage + 1) * DIAMOND_LIST_LIMIT)
//         }
//       } catch (err) {
//         console.log(err, 'err')
//       }
//     }, 300)
//   }

//   const callcomparision = (event) => {
//     const data = [...comparisiondata]
//     var newState = [...items]
//     if (event.target.checked) {
//       newState
//         .filter((itemdata) => itemdata._id === event.target.id)
//         .forEach((result) => {
//           data.push(result)
//         })
//       setComparisiondata(data)
//     } else {
//       setComparisiondata(
//         comparisiondata.filter((v) => v._id !== event.target.id),
//       )
//     }
//   }
//   const deletecomparision = (id) => {
//     var checkboxitem = document.querySelector('[data-id="d' + id + '"]')
//     if (checkboxitem.checked) {
//       checkboxitem.checked = false
//     }
//     setComparisiondata(comparisiondata.filter((v) => v._id !== id))
//   }
//   useEffect(() => {
//     daimondfilters()
//     // eslint-disable-next-line
//   }, [startdate, enddate])

//   return (
//     <React.Fragment>
//       <div className="main-body">
//         <div className="container">
//           <div className="row">
//             <div className="col-lg-12">
//               <div className="diamond-search-heading">
//                 <h1 className="main-body-heading">{t('Diamond Search')}</h1>
//                 <div className="main-body-top-status-bar-print-export-dropdown dropdown">
//                   <button className="print-export-dropdown-selected-icon d-none">
//                     <img
//                       src={base_assets + 'images/icons/printer-icon.png'}
//                       alt=""
//                     />
//                   </button>
//                   <button
//                     className="btn dropdown-toggle"
//                     type="button"
//                     id="dropdownMenuButton1"
//                     data-bs-toggle="dropdown"
//                     aria-expanded="false"
//                   >
//                     <img
//                       src={base_assets + 'images/icons/ellipsis-circular.png'}
//                       alt=""
//                     />
//                   </button>
//                   <ul
//                     className="dropdown-menu"
//                     aria-labelledby="dropdownMenuButton1"
//                   >
//                     <li
//                       className={parmissiondatashow?.inventory_diamond_search?.Print ? "dropdown-item print-dropdown-item" : "d-none"}
//                       onClick={(e) => {
//                         getprintdiamondsearch(e.target.value)
//                       }}
//                     >
//                       <div className="dropdown-item-img">
//                         <img
//                           src={base_assets + 'images/icons/printer-icon.png'}
//                           alt=""
//                         />
//                       </div>
//                       <span>{t('print')}</span>
//                     </li>
//                     <li
//                       className="dropdown-item"
//                       onClick={(e) => {
//                         e.preventDefault()
//                         e.stopPropagation()
//                         callexportrequest()
//                       }}
//                     >
//                       <div className="dropdown-item-img">
//                         <img
//                           src={base_assets + 'images/icons/export-x-icon.png'}
//                           alt=""
//                         />
//                       </div>
//                       <span>{t('export')}</span>
//                     </li>
//                     <li
//                       className="dropdown-item"
//                       data-bs-toggle="modal"
//                       data-bs-target="#ImportModal"
//                     >
//                       <div className="dropdown-item-img">
//                         <img
//                           src={base_assets + 'images/icons/import-icon.png'}
//                           alt=""
//                         />
//                       </div>
//                       <span>{t('import')}</span>
//                     </li>
//                     <li
//                       className="dropdown-item"
//                       data-bs-toggle="modal"
//                       data-bs-target="#socialModal"
//                       onClick={() => getsharediamondsearch()}
//                     >
//                       <div className="dropdown-item-img">
//                         <img
//                           src={base_assets + 'images/icons/share-icon.png'}
//                           alt=""
//                         />
//                       </div>
//                       <span>{t('share')}</span>
//                     </li>
//                     <li
//                       className="dropdown-item"
//                       data-bs-toggle="modal"
//                       data-bs-target="#columnModal"
//                     >
//                       <div className="dropdown-item-img">
//                         <img
//                           src={base_assets + 'images/icons/column-icon.png'}
//                           alt=""
//                         />
//                       </div>
//                       <span>{t('column')}</span>
//                     </li>
//                   </ul>
//                 </div>
//               </div>
//               <ImportExcelModal
//                 setImportfile={setImportfile}
//                 readExcel={readExcel}
//                 SampleExcel={SampleExcel}
//                 importfile={importfile}
//               />

//               <div className="diamond-search-wrap">
//                 <div className="diamond-search-wrap-width">
//                   <div
//                     className="accordion diamond-search-accordian"
//                     id="accordionDiamond"
//                   >
//                     <div className="diamond-search-accordian-tab">
//                       <button
//                         className="diamond-search-wrap-row diamond-search-accordian-tab-button"
//                         type="button"
//                         data-bs-toggle="collapse"
//                         data-bs-target="#diamondSearchTab"
//                         aria-expanded="true"
//                         aria-controls="diamondSearchTab"
//                       >
//                         <span>
//                           <img
//                             src={base_assets + 'images/icons/down-arrow.png'}
//                             alt=""
//                           />
//                           {t('Diamond Search')}
//                         </span>
//                       </button>


//                       <div className='main-body-top-status-bar-note-button common-dropdown replenish-date d-flex'>
//                         <button
//                           className="dropdown-toggle btn-style align-items-center d-flex diamond-search-accordian-tab-reset"
//                           type="button"
//                           id="dropdownMenuButton1"
//                           data-bs-toggle="dropdown"
//                           aria-expanded="false"
//                         >

//                           {t(datelable)}
//                         </button>
//                         <ul
//                           className="dropdown-menu"
//                           aria-labelledby="dropdownMenuButton1"
//                         >
//                           <li
//                             className={`dropdown-item ${datelable === 'Today' || datelable === 'Show All'
//                               ? 'active'
//                               : ''
//                               }`}
//                             onClick={() => changeDates('Today')}
//                           >
//                             {t('Today')}
//                           </li>
//                           <li
//                             className={`dropdown-item ${datelable === 'Yesterday' ? 'active' : ''
//                               }`}
//                             onClick={() => changeDates('Yesterday')}
//                           >
//                             {t('Yesterday')}
//                           </li>
//                           <li
//                             className={`dropdown-item ${datelable === '7days' ? 'active' : ''
//                               }`}
//                             onClick={() => changeDates('7days')}
//                           >
//                             {t('Last 7 days')}
//                           </li>
//                           <li
//                             className={`dropdown-item ${datelable === '30days' ? 'active' : ''
//                               }`}
//                             onClick={() => changeDates('30days')}
//                           >
//                             {t('Last 30 days')}
//                           </li>
//                           <li
//                             className={`dropdown-item ${datelable === 'ThisMonth' ? 'active' : ''
//                               }`}
//                             onClick={() => changeDates('ThisMonth')}
//                           >
//                             {t('This Month')}
//                           </li>
//                           <li
//                             className={`dropdown-item ${datelable === 'LastMonth' ? 'active' : ''
//                               }`}
//                             onClick={() => changeDates('LastMonth')}
//                           >
//                             {t('Last Month')}
//                           </li>
//                           <li
//                             className={`dropdown-item ${datelable === 'Custom Range' ? 'active' : ''
//                               }`}
//                             onClick={() => datePickerRef.current.setOpen(true)}
//                           >
//                             {t('Custom Range')}
//                           </li>
//                         </ul>
//                         <DatePicker
//                           selectsRange={true}
//                           monthsShown={2}
//                           startDate={startdate}
//                           endDate={enddate}
//                           onChange={(update) => {
//                             setStartdate(update[0])
//                             setEnddate(update[1])
//                             setDatelable('Custom Range')
//                           }}
//                           dateFormat="yyyy-MM-dd"
//                           ref={datePickerRef}
//                           autoComplete='none'
//                         />

//                         <button
//                           onClick={() => {
//                             daimondfilters('reset')
//                           }}
//                           className="diamond-search-accordian-tab-reset"
//                         >
//                           <img
//                             src={base_assets + 'images/icons/reset.png'}
//                             alt=""
//                           />
//                           <span>{t('reset filter')}</span>
//                         </button>
//                       </div>
//                     </div>
//                     <div
//                       id="diamondSearchTab"
//                       className="accordion-collapse collapse show"
//                       data-bs-parent="#accordionDiamond"
//                     >
//                       <div className="diamond-search-wrap-row">
//                         <div className="diamond-search-wrap-row-col col">
//                           <h6 className="diamond-search-wrap-row-col-heading">
//                             {t('Shape')}
//                           </h6>
//                           <div className="diamond-search-wrap-row-col-diamond-row">
//                             {daimondfilter?.Shape
//                               ? daimondfilter?.Shape.map((result, key) => {
//                                 return (
//                                   <div
//                                     key={key}
//                                     id={'shape' + result?._id}
//                                     data-id={result?._id}
//                                     onClick={(e) => callfilters(e, 'shape')}
//                                     className="diamond-search-wrap-row-col-diamond-row-single active resetshape"
//                                   >
//                                     <div className="diamond-search-wrap-row-col-diamond-row-single-img">
//                                       <img src={result?.logo} alt="" />
//                                     </div>
//                                     <p className="diamond-search-wrap-row-col-diamond-row-single-title">
//                                       {result?.name}
//                                     </p>
//                                   </div>
//                                 )
//                               })
//                               : ''}
//                           </div>
//                         </div>
//                         <div className="diamond-search-wrap-row-col col">
//                           <div className="diamond-search-wrap-row-col-ct">
//                             <h6 className="diamond-search-wrap-row-col-heading">
//                               {t('Price')}
//                             </h6>
//                             <div className="range-area">
//                               <Slider
//                                 range
//                                 min={daimondfilter?.Price?.min}
//                                 max={daimondfilter?.Price?.max}
//                                 value={val1}
//                                 onChange={setVal1}
//                                 step={0.1}
//                               />
//                               <div className="range-area-num">
//                                 <div className="range-area-num-single">
//                                   <span className="range-area-num-value">
//                                     {daimondfilter?.currency}
//                                   </span>
//                                   <span className="range-area-num-unit">
//                                     {val1[0]}
//                                   </span>
//                                 </div>
//                                 <div className="range-area-num-single">
//                                   <span className="range-area-num-value">
//                                     {daimondfilter?.currency}
//                                   </span>
//                                   <span className="range-area-num-unit">
//                                     {val1[1]}
//                                   </span>
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                           <div className="diamond-search-wrap-row-col-ct">
//                             <h6 className="diamond-search-wrap-row-col-heading">
//                               {t('Carat')}
//                             </h6>
//                             <div className="range-area">
//                               <Slider
//                                 range
//                                 min={daimondfilter?.Carat?.min}
//                                 max={daimondfilter?.Carat?.max}
//                                 value={val2}
//                                 onChange={setVal2}
//                                 step={0.1}
//                               />
//                               <div className="range-area-num">
//                                 <div className="range-area-num-single">
//                                   <span className="range-area-num-value">

//                                     {val2[0]}
//                                   </span>
//                                   <span className="range-area-num-unit">
//                                     {t('Ct')}
//                                   </span>
//                                 </div>
//                                 <div className="range-area-num-single">
//                                   <span className="range-area-num-value">

//                                     {val2[1]}
//                                   </span>
//                                   <span className="range-area-num-unit">
//                                     {t('Ct')}
//                                   </span>
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                         <div className="diamond-search-wrap-row-col col">
//                           <div className="diamond-search-wrap-row-col-ct">
//                             <h6 className="diamond-search-wrap-row-col-heading">
//                               {t('Colour')}
//                             </h6>
//                             <div className="diamond-tab-row row m-0">
//                               {daimondfilter?.StoneColor
//                                 ? daimondfilter?.StoneColor?.map(
//                                   (result, key) => {
//                                     return (
//                                       <React.Fragment key={key}>
//                                         <input
//                                           key={key}
//                                           id={result?._id}
//                                           value={result?.code}
//                                           type="checkbox"
//                                           onClick={(e) =>
//                                             callfilters(e, 'stonecolor')
//                                           }
//                                         />
//                                         <label
//                                           htmlFor={result?._id}
//                                           id={'stonecolor' + result?._id}
//                                           className="diamond-tab-row-tab  active resetcolor"
//                                         >
//                                           {result?.code}
//                                         </label>
//                                       </React.Fragment>
//                                     )
//                                   },
//                                 )
//                                 : ''}
//                             </div>
//                           </div>
//                           <div className="diamond-search-wrap-row-col-ct">
//                             <h6 className="diamond-search-wrap-row-col-heading">
//                               {t('clarity')}
//                             </h6>
//                             <div className="diamond-tab-row row m-0">
//                               {daimondfilter?.Clarity
//                                 ? daimondfilter?.Clarity.map((result, key) => {
//                                   return (
//                                     <React.Fragment key={key}>
//                                       <input
//                                         key={key}
//                                         id={result?._id}
//                                         value={result?.code}
//                                         type="checkbox"
//                                         onClick={(e) =>
//                                           callfilters(e, 'clarity')
//                                         }
//                                       />
//                                       <label
//                                         htmlFor={result?._id}
//                                         id={'clarity' + result?._id}
//                                         className="diamond-tab-row-tab   active resetclarity"
//                                       >
//                                         {result?.code}
//                                       </label>
//                                     </React.Fragment>
//                                   )
//                                 })
//                                 : ''}
//                             </div>
//                           </div>
//                           <div className="diamond-search-wrap-row-col-ct">
//                             <h6 className="diamond-search-wrap-row-col-heading">
//                               {t('cut')}
//                             </h6>
//                             <div className="diamond-tab-row row m-0">
//                               {daimondfilter?.Cut
//                                 ? daimondfilter?.Cut.map((result, key) => {
//                                   return (
//                                     <React.Fragment key={key}>
//                                       <input
//                                         key={key}
//                                         id={result?._id}
//                                         value={result?.code}
//                                         type="checkbox"
//                                         onClick={(e) => callfilters(e, 'cut')}
//                                       />
//                                       <label
//                                         htmlFor={result?._id}
//                                         id={'cut' + result?._id}
//                                         className="diamond-tab-row-tab col active resetcut"
//                                       >
//                                         {result?.code}
//                                       </label>
//                                     </React.Fragment>
//                                   )
//                                 })
//                                 : ''}
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                       <div
//                         className="accordion advanced-options-accordian"
//                         id="accordionAdvanced"
//                       >
//                         <div
//                           id="advancedOptions"
//                           className="accordion-collapse collapse"
//                           data-bs-parent="#accordionAdvanced"
//                         >
//                           <div className="diamond-search-wrap-row">
//                             <div className="diamond-search-wrap-row-col col">
//                               <div className="diamond-search-wrap-row-col-ct">
//                                 <h6 className="diamond-search-wrap-row-col-heading">
//                                   {t('Polish')}
//                                 </h6>
//                                 <div className="diamond-tab-row row m-0">
//                                   {daimondfilter?.Polish
//                                     ? daimondfilter?.Polish.map(
//                                       (result, key) => {
//                                         return (
//                                           <React.Fragment key={key}>
//                                             <input
//                                               key={key}
//                                               id={result?._id}
//                                               value={result?.code}
//                                               type="checkbox"
//                                               onClick={(e) =>
//                                                 callfilters(e, 'polish')
//                                               }
//                                             />
//                                             <label
//                                               htmlFor={result?._id}
//                                               id={'polish' + result?._id}
//                                               className="diamond-tab-row-tab symmetry-btn w-25 active resetpolish"
//                                             >
//                                               {result?.code}
//                                             </label>
//                                           </React.Fragment>
//                                         )
//                                       },
//                                     )
//                                     : ''}
//                                 </div>
//                               </div>
//                               <div className="diamond-search-wrap-row-col-ct">
//                                 <h6 className="diamond-search-wrap-row-col-heading">
//                                   {t('depth')}
//                                 </h6>
//                                 <div className="range-area">
//                                   <Slider
//                                     range
//                                     min={daimondfilter?.Depth?.min}
//                                     max={daimondfilter?.Depth?.max}
//                                     value={val3}
//                                     onChange={setVal3}
//                                   />
//                                   <div className="range-area-num">
//                                     <div className="range-area-num-single">
//                                       <span className="range-area-num-value">

//                                         {val3[0]}
//                                       </span>
//                                       <span className="range-area-num-unit">
//                                         %
//                                       </span>
//                                     </div>
//                                     <div className="range-area-num-single">
//                                       <span className="range-area-num-value">

//                                         {val3[1]}
//                                       </span>
//                                       <span className="range-area-num-unit">
//                                         %
//                                       </span>
//                                     </div>
//                                   </div>
//                                 </div>
//                               </div>
//                               <div className="diamond-search-wrap-row-col-ct">
//                                 <h6 className="diamond-search-wrap-row-col-heading">
//                                   {t('Location')}
//                                 </h6>
//                                 <div className="diamond-tab-row row m-0">
//                                   {daimondfilter?.Location
//                                     ? daimondfilter?.Location.map(
//                                       (result, key) => {
//                                         return (
//                                           <React.Fragment key={key}>
//                                             <input
//                                               key={key}
//                                               id={result?._id}
//                                               value={result?.name}
//                                               type="checkbox"
//                                               onClick={(e) =>
//                                                 callfilters(e, 'Location')
//                                               }
//                                             />
//                                             <label
//                                               htmlFor={result?._id}
//                                               id={'Location' + result?._id}
//                                               className="diamond-tab-row-tab Location-btn active resetLocation"
//                                             >
//                                               {result?.name}
//                                             </label>
//                                           </React.Fragment>
//                                         )
//                                       },
//                                     )
//                                     : ''}
//                                 </div>
//                               </div>
//                             </div>
//                             <div className="diamond-search-wrap-row-col col">
//                               <div className="diamond-search-wrap-row-col-ct">
//                                 <h6 className="diamond-search-wrap-row-col-heading">
//                                   {t('Symmetry')}
//                                 </h6>
//                                 <div className="diamond-tab-row row m-0">
//                                   {daimondfilter?.Symmetry
//                                     ? daimondfilter?.Symmetry.map(
//                                       (result, key) => {
//                                         return (
//                                           <React.Fragment key={key}>
//                                             <input
//                                               key={key}
//                                               id={result?._id}
//                                               value={result?.code}
//                                               type="checkbox"
//                                               onClick={(e) =>
//                                                 callfilters(e, 'symmetry')
//                                               }
//                                             />
//                                             <label
//                                               htmlFor={result?._id}
//                                               id={'symmetry' + result?._id}
//                                               className="diamond-tab-row-tab symmetry-btn active resetsymmetry"
//                                             >
//                                               {result?.code}
//                                             </label>
//                                           </React.Fragment>
//                                         )
//                                       },
//                                     )
//                                     : ''}
//                                 </div>
//                               </div>
//                               <div className="diamond-search-wrap-row-col-ct">
//                                 <h6 className="diamond-search-wrap-row-col-heading">
//                                   {t('Table')}
//                                 </h6>
//                                 <div className="range-area">
//                                   <Slider
//                                     range
//                                     min={daimondfilter?.Table?.min}
//                                     max={daimondfilter?.Table?.max}
//                                     value={val4}
//                                     onChange={setVal4}
//                                   />
//                                   <div className="range-area-num">
//                                     <div className="range-area-num-single">
//                                       <span className="range-area-num-value">

//                                         {val4[0]}
//                                       </span>
//                                       <span className="range-area-num-unit">
//                                         %
//                                       </span>
//                                     </div>
//                                     <div className="range-area-num-single">
//                                       <span className="range-area-num-value">

//                                         {val4[1]}
//                                       </span>
//                                       <span className="range-area-num-unit">
//                                         %
//                                       </span>
//                                     </div>
//                                   </div>
//                                 </div>
//                               </div>
//                             </div>
//                             <div className="diamond-search-wrap-row-col col">
//                               <div className="diamond-search-wrap-row-col-ct">
//                                 <h6 className="diamond-search-wrap-row-col-heading">
//                                   {t('Fluorescence')}
//                                 </h6>
//                                 <div className="diamond-tab-row row m-0">
//                                   {daimondfilter?.Fluorescence
//                                     ? daimondfilter?.Fluorescence.map(
//                                       (result, key) => {
//                                         return (
//                                           <React.Fragment key={key}>
//                                             <input
//                                               key={key}
//                                               id={result?._id}
//                                               value={result?.code}
//                                               type="checkbox"
//                                               onClick={(e) =>
//                                                 callfilters(e, 'fluorescence')
//                                               }
//                                             />
//                                             <label
//                                               htmlFor={result?._id}
//                                               id={
//                                                 'fluorescence' + result?._id
//                                               }
//                                               className="diamond-tab-row-tab fluorescence-btn active resetfluorescence"
//                                             >
//                                               {result?.code}
//                                             </label>
//                                           </React.Fragment>
//                                         )
//                                       },
//                                     )
//                                     : ''}
//                                 </div>
//                               </div>
//                               <div className="diamond-search-wrap-row-col-ct">
//                                 <h6 className="diamond-search-wrap-row-col-heading">
//                                   {t('Lab')}
//                                 </h6>
//                                 <div className="diamond-tab-row row m-0">
//                                   {daimondfilter?.Lbs
//                                     ? daimondfilter?.Lbs.map((result, key) => {
//                                       return (
//                                         <React.Fragment key={key}>
//                                           <input
//                                             key={key}
//                                             id={'Lbs' + key}
//                                             value={result}
//                                             type="checkbox"
//                                             onClick={(e) =>
//                                               callfilters(e, 'lbs')
//                                             }
//                                           />
//                                           <label
//                                             htmlFor={'Lbs' + key}
//                                             id={'lLbs' + key}
//                                             className="diamond-tab-row-tab text-uppercase lab-btn active resetlab"
//                                           >
//                                             {result}
//                                           </label>
//                                         </React.Fragment>
//                                       )
//                                     })
//                                     : ''}
//                                 </div>
//                               </div>
//                               <div className="diamond-search-wrap-row-col-ct">
//                                 <h6 className="diamond-search-wrap-row-col-heading">
//                                   {t('Status')}
//                                 </h6>
//                                 <div className="diamond-tab-row row m-0">
//                                   {daimondfilter?.Status
//                                     ? daimondfilter?.Status.sort(
//                                       (a, b) => a - b,
//                                     ).map((result, key) => {
//                                       return (
//                                         <React.Fragment key={key}>
//                                           <input
//                                             key={key}
//                                             id={result}
//                                             value={result}
//                                             type="checkbox"
//                                             onClick={(e) =>
//                                               callfilters(e, 'status')
//                                             }
//                                           />

//                                           <label
//                                             htmlFor={result}
//                                             id={'status' + result}
//                                             className="diamond-tab-row-tab status-btn active resetstatus"
//                                           >
//                                             {result === "1"
//                                               ? "Stock"
//                                               : result === "2"
//                                                 ? 'Reserve'
//                                                 : result === "3"
//                                                   ? 'Custom Order'
//                                                   : result === "4"
//                                                     ? 'Transits'
//                                                     : ''}
//                                           </label>
//                                         </React.Fragment>
//                                       )
//                                     })
//                                     : ''}
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                         <div className="advanced-options-accordian-button-wrap">
//                           <div className="row justify-content-center">
//                             <div className="col-md-3">
//                               <button
//                                 className={
//                                   'w-100 com-btn mt-2 mb-2 ' + FilterSubmitClass
//                                 }
//                                 onClick={submitfilters}
//                               >
//                                 {t('Submit Filter')}
//                               </button>
//                             </div>
//                           </div>
//                           <button
//                             className="diamond-search-wrap-row 
//                             advanced-options-accordian-button"
//                             type="button"
//                             data-bs-toggle="collapse"
//                             data-bs-target="#advancedOptions"
//                             aria-expanded="true"
//                             aria-controls="advancedOptions"
//                           >
//                             <span className="advanced-text">
//                               {t('Advanced Options')}
//                               <img
//                                 src={base_assets + 'images/icons/add-icon.png'}
//                                 alt=""
//                               />
//                             </span>
//                             <span className="less-text">
//                               {t('Less Options')}
//                               <img
//                                 src={
//                                   base_assets + 'images/icons/minus-icon.png'
//                                 }
//                                 alt=""
//                               />
//                             </span>
//                           </button>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                   <div className="diamond-search-wrap-nav">
//                     <div
//                       className="diamond-search-wrap-nav-tab"
//                       id="nav-tab"
//                       role="tablist"
//                     >
//                       <button
//                         className="nav-link active"
//                         id="nav-home-tab"
//                         data-bs-toggle="tab"
//                         data-bs-target="#nav-home"
//                         type="button"
//                         role="tab"
//                         aria-controls="nav-home"
//                         aria-selected="true"
//                       >
//                         {t('results')}
//                         <span className="total-row">
//                           ({totalresult ? totalresult : ''})
//                         </span>
//                       </button>
//                       <button
//                         className="nav-link"
//                         id="nav-profile-tab"
//                         data-bs-toggle="tab"
//                         data-bs-target="#nav-profile"
//                         type="button"
//                         role="tab"
//                         aria-controls="nav-profile"
//                         aria-selected="false"
//                       >
//                         {t('Comparision')}
//                         <span className="total-row">
//                           ({comparisiondata ? comparisiondata?.length : '0'})
//                         </span>
//                       </button>
//                     </div>
//                     <div className="tab-content" id="nav-tabContent">
//                       <div
//                         className="tab-pane fade show active"
//                         id="nav-home"
//                         role="tabpanel"
//                         aria-labelledby="nav-home-tab"
//                       >
//                         <div className="common-sub-table-wrap add-row">
//                           <div className="main-body-main-table-wrap">
//                             <InfiniteScroll
//                               dataLength={items ? items?.length : 0}
//                               next={fetchMoreData}
//                               hasMore={
//                                 Number(totalresult) >
//                                 (listPage + 1) * DIAMOND_LIST_LIMIT
//                               }
//                               loader={
//                                 Number(totalresult) >
//                                 (listPage + 1) * DIAMOND_LIST_LIMIT ? (
//                                   <h6>{t('Loading more items...')}</h6>
//                                 ) : (
//                                   ''
//                                 )
//                               }
//                             >
//                               <table
//                                 id="tbl_createTransfer1"
//                                 className="common-table first-row-gray w-100"
//                               >
//                                 <thead>
//                                   <tr>
//                                     <th />
//                                     <th>#</th>
//                                     <th>{t('Shape')}</th>
//                                     <th>{t('Carat')}</th>
//                                     <th>{t('Colour')}</th>
//                                     <th>{t('Clarity')}</th>
//                                     <th>{t('Cut')}</th>
//                                     <th>{t('Polish')}</th>
//                                     <th>{t('Symmetry')}</th>
//                                     <th>{t('Certificate')}</th>
//                                     <th>{t('Price')}</th>
//                                     <th>{t('Location')}</th>
//                                     <th className="text-center">
//                                       {t('Detail')}
//                                     </th>
//                                     <th className="text-center">
//                                       {t('Status')}
//                                     </th>
//                                   </tr>
//                                 </thead>
//                                 <tbody>
//                                   <>
//                                     {items
//                                       ? items.map((result, key) => {
//                                         return (
//                                           <tr key={key}>
//                                             <td>
//                                               <div className="com-check">
//                                                 <input
//                                                   id={result?._id}
//                                                   data-id={'d' + result?._id}
//                                                   onClick={callcomparision}
//                                                   type="checkbox"
//                                                 />
//                                                 <label
//                                                   htmlFor={result?._id}
//                                                   className="com-check-label"
//                                                 />
//                                               </div>
//                                             </td>
//                                             <td>{key + 1}</td>
//                                             <td className="diamond-pro-img">
//                                               <img
//                                                 src={
//                                                   result?.Shape
//                                                     ? result?.Shape
//                                                     : base_assets +
//                                                     'images/icon/camera_profile.png'
//                                                 }
//                                                 alt=""
//                                               />
//                                             </td>
//                                             <td>
//                                               <Link
//                                                 className="link-color text-decoration-none"
//                                               >
//                                                 {result?.Carat
//                                                   ? result?.Carat
//                                                   : ''}
//                                               </Link>
//                                             </td>
//                                             <td>
//                                               {result?.Colour
//                                                 ? result?.Colour
//                                                 : ''}
//                                             </td>
//                                             <td>
//                                               {result?.Clarity
//                                                 ? result?.Clarity
//                                                 : ''}
//                                             </td>
//                                             <td>
//                                               {result?.Cut ? result?.Cut : ''}
//                                             </td>
//                                             <td>
//                                               {result?.Polish
//                                                 ? result?.Polish
//                                                 : ''}
//                                             </td>
//                                             <td>
//                                               {result?.Symmetry
//                                                 ? result?.Symmetry
//                                                 : ''}
//                                             </td>
//                                             <td>
//                                               <Link
//                                                 className="link-color"
//                                                 target="_blank"
//                                                 to={
//                                                   result?.CertificationUrl
//                                                     ? result?.CertificationUrl
//                                                     : ''
//                                                 }
//                                               >
//                                                 {result?.Certification
//                                                   ? result?.Certification
//                                                   : ''}
//                                               </Link>
//                                             </td>
//                                             <td>
//                                               {result?.Price
//                                                 ? result?.Price
//                                                 : ''}
//                                             </td>
//                                             <td>
//                                               {result?.Location
//                                                 ? result?.Location
//                                                 : ''}
//                                             </td>
//                                             <td className="text-center eye-img">
//                                               <Link
//                                                 state={{
//                                                   daimondid: result?._id,
//                                                 }}
//                                                 to="/app/inventory/detailDiamond"
//                                                 style={[3,4].includes(result?.Status) ? { pointerEvents: "none", opacity: "0.5" } : null}
//                                               >
//                                                 <img
//                                                   src={
//                                                     base_assets +
//                                                     'images/icons/green-eye.png'
//                                                   }
//                                                   alt=""
//                                                 />
//                                               </Link>
//                                             </td>

//                                             <td className="text-center">
//                                               <div
//                                                 className={
//                                                   result?.Status === 1
//                                                     ? 'status-yellow light-blue tooltip-area-up'
//                                                     : result?.Status === 2
//                                                       ? 'status-yellow light-yellow-bg tooltip-area-up'
//                                                       : result?.Status === 3
//                                                         ? 'status-yellow bg-danger tooltip-area-up'
//                                                         : result?.Status === 4
//                                                           ? 'status-gray-tab light-gray-bg tooltip-area-up'
//                                                           : 'status-color bg-main-green tooltip-area-up'

//                                                 }
//                                               >
//                                                 {result?.reserveDate ? (
//                                                   <span className="tooltip-area-up-text">

//                                                     {result?.customer}
//                                                     <br />
//                                                     {formatDate(
//                                                       result?.reserveDate,
//                                                     )}
//                                                   </span>
//                                                 ) : result?.Status === 1 ? (
//                                                   <span className="tooltip-area-up-text">
//                                                     {t('Stock')}
//                                                   </span>
//                                                 ) : result?.Status === 3 ? (
//                                                   <span className="tooltip-area-up-text">
//                                                     {t('Custom Order')}
//                                                   </span>
//                                                 ) : result?.Status === 4 ? (
//                                                   <span className="tooltip-area-up-text">
//                                                     {t('Transit')}
//                                                   </span>
//                                                 ) : (
//                                                   ''
//                                                 )}
//                                               </div>
//                                             </td>
//                                           </tr>
//                                         )
//                                       })
//                                       : ''}
//                                   </>
//                                 </tbody>
//                               </table>
//                             </InfiniteScroll>
//                           </div>
//                         </div>
//                       </div>
//                       <div
//                         className="tab-pane fade"
//                         id="nav-profile"
//                         role="tabpanel"
//                         aria-labelledby="nav-profile-tab"
//                       >
//                         <div className="common-sub-table-wrap add-row">
//                           <div className="main-body-main-table-wrap">
//                             <table
//                               id="tbl_createTransfer2"
//                               className="common-table first-row-gray w-100"
//                             >
//                               <thead>
//                                 <tr>
//                                   <th />
//                                   <th>#</th>
//                                   <th>{t('Shape')}</th>
//                                   <th>{t('Carat')}</th>
//                                   <th>{t('Colour')}</th>
//                                   <th>{t('Clarity')}</th>
//                                   <th>{t('Cut')}</th>
//                                   <th>{t('Polish')}</th>
//                                   <th>{t('Symmetry')}</th>
//                                   <th>{t('Certificate')}</th>
//                                   <th>{t('Price')}</th>
//                                   <th>{t('Location')}</th>
//                                   <th className="text-center">{t('Detail')}</th>
//                                   <th className="text-center">{t('Status')}</th>
//                                 </tr>
//                               </thead>
//                               <tbody>
//                                 <>
//                                   {comparisiondata
//                                     ? comparisiondata.map((result, key) => {
//                                       return (
//                                         <tr key={key}>
//                                           <td>
//                                             <button
//                                               className="delete-row-btn"
//                                               onClick={() =>
//                                                 deletecomparision(result?._id)
//                                               }
//                                             >
//                                               <img
//                                                 src={
//                                                   base_assets +
//                                                   'images/icons/delete-icon.png'
//                                                 }
//                                                 alt=""
//                                               />
//                                             </button>
//                                           </td>
//                                           <td>{key + 1}</td>
//                                           <td className="diamond-pro-img">
//                                             <img
//                                               src={
//                                                 result?.Shape
//                                                   ? result?.Shape
//                                                   : base_assets +
//                                                   'images/icon/camera_profile.png'
//                                               }
//                                               alt=""
//                                             />
//                                           </td>
//                                           <td>
//                                             <Link className="link-color">
//                                               {result?.Carat
//                                                 ? result?.Carat
//                                                 : ''}
//                                             </Link>
//                                           </td>
//                                           <td>
//                                             {result?.Colour
//                                               ? result?.Colour
//                                               : ''}
//                                           </td>
//                                           <td>
//                                             {result?.Clarity
//                                               ? result?.Clarity
//                                               : ''}
//                                           </td>
//                                           <td>
//                                             {result?.Cut ? result?.Cut : ''}
//                                           </td>
//                                           <td>
//                                             {result?.Polish
//                                               ? result?.Polish
//                                               : ''}
//                                           </td>
//                                           <td>
//                                             {result?.Symmetry
//                                               ? result?.Symmetry
//                                               : ''}
//                                           </td>
//                                           <td>
//                                             <a
//                                               className="link-color"
//                                               target="_blank"
//                                               href={
//                                                 result?.CertificationUrl
//                                                   ? result?.CertificationUrl
//                                                   : ''
//                                               }
//                                               rel="noreferrer"
//                                             >
//                                               {result?.Certification
//                                                 ? result?.Certification
//                                                 : ''}
//                                             </a>
//                                           </td>
//                                           <td>
//                                             {result?.Price ? result?.Price : ''}
//                                           </td>
//                                           <td>
//                                             {result?.Location
//                                               ? result?.Location
//                                               : ''}
//                                           </td>
//                                           <td className="text-center eye-img">
//                                             <Link
//                                               state={{ daimondid: result?._id }}
//                                               to="/app/inventory/detailDiamond"
//                                             >
//                                               <img
//                                                 src={
//                                                   base_assets +
//                                                   'images/icons/green-eye.png'
//                                                 }
//                                                 alt=""
//                                               />
//                                             </Link>
//                                           </td>

//                                           <td className="text-center">
//                                             <div
//                                               className={
//                                                 result?.Status === 1
//                                                   ? 'status-yellow light-blue tooltip-area-up'
//                                                   : result?.Status === 2
//                                                     ? 'status-yellow light-yellow-bg tooltip-area-up'
//                                                     : result?.Status === 3
//                                                       ? 'status-yellow bg-danger tooltip-area-up'
//                                                       : 'status-color bg-main-green tooltip-area-up'
//                                               }
//                                             >
//                                               {result?.reserveDate ? (
//                                                 <span className="tooltip-area-up-text">

//                                                   {result?.customer} <br />
//                                                   {formatDate(
//                                                     result?.reserveDate,
//                                                   )}
//                                                 </span>
//                                               ) : result?.Status === 1 ? (
//                                                 <span className="tooltip-area-up-text">
//                                                   {t('Stock')}
//                                                 </span>
//                                               ) : result?.Status === 3 ? (
//                                                 <span className="tooltip-area-up-text">
//                                                   {t('Custom Order')}
//                                                 </span>
//                                               ) : result?.Status === 4 ? (
//                                                 <span className="tooltip-area-up-text">
//                                                   {t('Transit')}
//                                                 </span>
//                                               ) : (
//                                                 ''
//                                               )}
//                                             </div>
//                                           </td>
//                                         </tr>
//                                       )
//                                     })
//                                     : ''}
//                                 </>
//                               </tbody>
//                             </table>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//         <SocialModal shareUrl={socialurl} shareloader={shareloader} />
//       </div>
//       <TableColumnModal></TableColumnModal>
//     </React.Fragment>
//   )
// }

// export default DiamondSearch;


import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import 'react-datepicker/dist/react-datepicker.css';
import 'rc-slider/assets/index.css';
import Slider from 'rc-slider';
import DatePicker from 'react-datepicker';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';
import RefreshIcon from '@mui/icons-material/Refresh';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import TableRowsOutlinedIcon from '@mui/icons-material/TableRowsOutlined';
import GridOnOutlinedIcon from '@mui/icons-material/GridOnOutlined';
import WindowOutlinedIcon from '@mui/icons-material/WindowOutlined';
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import ViewColumnOutlinedIcon from '@mui/icons-material/ViewColumnOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import RestartAltOutlinedIcon from '@mui/icons-material/RestartAltOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import FilterListIcon from '@mui/icons-material/FilterList';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { _Api, Api_form } from '../api/_call';
import DeleteModal from '../common/modules/deletemodal';
import TableColumnModal from '../common/modules/tableColumn';
import { ImportExcelModal } from '../common/modules/importExcel';
import SocialModal from '../common/modules/SocialModal/SocialModal';
import { Pagination } from '../common/Pagination';
import {
  success,
  error,
  loading,
  Updateloading,
} from '../common/helpers/toastify';
import { formatDate } from '../common/helpers/formatDate';
import './diamond.scss';
import './DiamondSearchPage.scss';
import DeallocateModal from './DeallocateModal';

const DEFAULT_PAGE_SIZE = 100;
const PAGE_SIZE_OPTIONS = [100, 200, 300].map((n) => ({ label: n, value: n }));

const EMPTY_SELECTION = {
  shape: [],
  color: [],
  clarity: [],
  cut: [],
  polish: [],
  symmetry: [],
  fluorescence: [],
  lab: [],
  status: [],
  location: [],
};

const VIDEO_URL_PATTERN = /\.(mp4|mov|webm|ogg|m4v)(\?|$)/i;

const mediaUrl = (m) => (typeof m === 'string' ? m : m?.url || m?.image || m?.path || '');

const mediaList = (value) => (Array.isArray(value) ? value : [value]).map(mediaUrl).filter(Boolean);

const previewMediaOf = (record) => {
  if (!record) return '';
  const images = mediaList(record.image);
  const videos = mediaList(record.video);
  if (mediaUrl(record.DefaultMedia)) return mediaUrl(record.DefaultMedia);
  if (String(record.DefaultMediaType).toLowerCase() === 'video' && videos[0]) return videos[0];
  return (
    mediaUrl(record.DefaultImage) ||
    mediaUrl(record.defaultImage) ||
    images[Number(record.DefaultImageIndex) || 0] ||
    images[0] ||
    videos[0] ||
    ''
  );
};

const renderPreviewMedia = (url, alt) =>
  VIDEO_URL_PATTERN.test(url) ? (
    <video className="is-media" src={url} autoPlay muted loop playsInline />
  ) : (
    <img className="is-media" src={url} alt={alt} />
  );

const categoryText = (record, field = 'Category_name') => {
  const category = record?.Category;
  if (category && !Array.isArray(category) && typeof category === 'object') {
    return category.value || category.key || category[field] || category.name || category.label || '';
  }
  const list = Array.isArray(category) ? category : [];
  const fromList = list
    .map((c) => (c && typeof c === 'object' ? c.value || c.key || c[field] || c.name || c.label : ''))
    .filter(Boolean);
  return fromList.length ? fromList.join(', ') : record?.[field] ?? '';
};

const customJewelryNames = (record) => {
  const list = Array.isArray(record?.CustomJewelry)
    ? record.CustomJewelry
    : record?.CustomJewelry
      ? [record.CustomJewelry]
      : [];
  return list
    .map((c) => {
      if (c && typeof c === 'object') {
        return c.Category_name || c.name || c.label || c.CustomJewelry_name || '';
      }
      return c == null ? '' : String(c);
    })
    .filter(Boolean);
};

const customJewelryText = (record) => customJewelryNames(record).join(', ');

const customJewelryPreview = (record, limit = 3) => {
  const names = customJewelryNames(record);
  if (names.length <= limit) return names.join(', ');
  return `${names.slice(0, limit).join(', ')}...`;
};

const COLUMN_STORAGE_KEY = 'diamondSearchColumns';

const COLUMN_KEYS = [
  'status', 'shape', 'category', 'carat', 'colour', 'clarity', 'cut', 'polish',
  'symmetry', 'fluorescence', 'depth', 'table', 'gridle', 'culet', 'measurement',
  'gradedBy', 'certification', 'stockId', 'price', 'location', 'customJewelry',
];

const FIXED_COLUMN_KEYS = [
  'status', 'shape', 'carat', 'colour', 'clarity', 'cut', 'polish',
  'symmetry', 'gradedBy', 'certification', 'price', 'location',
];

const isFixedColumn = (key) => FIXED_COLUMN_KEYS.includes(key);

const loadColumnPrefs = () => {
  let saved = [];
  try {
    saved = JSON.parse(localStorage.getItem(COLUMN_STORAGE_KEY)) || [];
  } catch (err) {
    saved = [];
  }
  const known = saved.filter((c) => COLUMN_KEYS.includes(c?.key));
  const missing = COLUMN_KEYS.filter((key) => !known.some((c) => c.key === key)).map((key) => ({
    key,
    visible: true,
  }));
  return [...known.map((c) => ({ key: c.key, visible: c.visible !== false })), ...missing];
};

const toPriceNumber = (value) => {
  const n = Number(String(value ?? '').replace(/[^0-9.-]/g, ''));
  return Number.isFinite(n) ? n : 0;
};

const sumPrices = (list) => list.reduce((total, item) => total + toPriceNumber(item?.Price), 0);

const formatPrice = (value) => {
  if (value === undefined || value === null || value === '') return '';
  return `$${toPriceNumber(value).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

const STATUS_META = {
  1: { label: 'Stock', className: 'is-stock' },
  2: { label: 'Reserve', className: 'is-reserve' },
  3: { label: 'Custom Order', className: 'is-custom' },
  4: { label: 'Transit', className: 'is-transit' },
};

const TRANSIT_STATUS = 4;

const idsOf = (list) => (list || []).map((item) => item?._id);
const pickSelected = (selected, all) => (selected?.length ? selected : all);
const toRange = (range) => [Number(range?.min) || 0, Number(range?.max) || 0];
const formatRangeDate = (date) =>
  date
    ? date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    })
    : '';

// const toApiDate = (date) => {
//   const pad = (n) => String(n).padStart(2, '0');
//   return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
// };
const toApiDate = (date) => {
  const now = new Date();
  return new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    now.getHours(),
    now.getMinutes(),
    now.getSeconds(),
    now.getMilliseconds()
  ).toISOString();
};

const formatInputDate = (date) => {
  if (!date) return '';
  const pad = (n) => String(n).padStart(2, '0');
  return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()}`;
};

const parseInputDate = (text) => {
  const match = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec(String(text).trim());
  if (!match) return null;
  const [, d, m, y] = match.map(Number);
  const date = new Date(y, m - 1, d);
  return date.getDate() === d && date.getMonth() === m - 1 ? date : null;
};

const OLD_DATE_PRESETS = [
  ['Show All', 'Show All'],
  ['Today', 'Today'],
  ['Yesterday', 'Yesterday'],
  ['7days', 'Last 7 Days'],
  ['30days', 'Last 30 Days'],
  ['ThisMonth', 'This Month'],
  ['LastMonth', 'Last Month'],
  ['Custom Range', 'Custom Range'],
];

const DATE_PRESETS = [
  ['Today', 'Today'],
  ['Yesterday', 'Yesterday'],
  ['7days', 'Last 7 days'],
  ['30days', 'Last 30 days'],
  ['ThisMonth', 'This month'],
  ['LastMonth', 'Last month'],
  ['ThisYear', 'This year'],
  ['Show All', 'Show All'],
];

const DiamondSearch = () => {
  const { t } = useTranslation();
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;
  const parmissiondatashow = useSelector((state) => state.app.ApplyParmission);

  const [filters, setFilters] = useState(null);
  const [sel, setSel] = useState(EMPTY_SELECTION);
  const [price, setPrice] = useState([0, 0]);
  const [carat, setCarat] = useState([0, 0]);
  const [depth, setDepth] = useState([0, 0]);
  const [table, setTable] = useState([0, 0]);
  // const [startdate, setStartdate] = useState(() => {
  //   const today = new Date();
  //   return new Date(today.getFullYear(), today.getMonth(), today.getDate());
  // });
  // const [enddate, setEnddate] = useState(() => {
  //   const today = new Date();
  //   return new Date(today.getFullYear(), today.getMonth() + 1, 0);
  // });
  // const [datelable, setDatelable] = useState('Custom Range');
  // const [startdate, setStartdate] = useState(null);
  // const [enddate, setEnddate] = useState(null);
  // const [datelable, setDatelable] = useState('Show All');
  // const [startdate, setStartdate] = useState(
  //   () => new Date(new Date().getFullYear(), new Date().getMonth(), 1),
  // );
  // const [enddate, setEnddate] = useState(
  //   () => new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
  // );
  // const [datelable, setDatelable] = useState('ThisMonth');
  const [startdate, setStartdate] = useState(null);
  const [enddate, setEnddate] = useState(null);
  const [datelable, setDatelable] = useState('Show All');
  const [customRangeOpen, setCustomRangeOpen] = useState(false);

  const [items, setItems] = useState([]);
  const [totalresult, setTotalresult] = useState(0);
  const [skip, setSkip] = useState(0);
  const [limit, setLimit] = useState(DEFAULT_PAGE_SIZE);
  const resultsRef = useRef(null);
  const [stats, setStats] = useState({});
  const [comparison, setComparison] = useState([]);
  const [activeTab, setActiveTab] = useState('results');
  const [viewMode, setViewMode] = useState('table');
  const [searchText, setSearchText] = useState('');

  const [showMoreFilters, setShowMoreFilters] = useState(false);
  const [showAnalytics, setShowAnalytics] = useState(true);
  const [moreActionsOpen, setMoreActionsOpen] = useState(false);
  const [dateMenuOpen, setDateMenuOpen] = useState(false);
  const [limitMenuOpen, setLimitMenuOpen] = useState(false);
  const [confirmAction, setConfirmAction] = useState('reserve');
  const [draftStart, setDraftStart] = useState(null);
  const [draftEnd, setDraftEnd] = useState(null);
  const [startText, setStartText] = useState('');
  const [endText, setEndText] = useState('');

  const [importfile, setImportfile] = useState();
  const [socialurl, setSocialurl] = useState();
  const [shareloader, setShareloader] = useState(false);
  const [diamondExportFormat, setDiamondExportFormat] = useState('xlsx');
  const [diamondSampleFormat, setDiamondSampleFormat] = useState('xlsx');
  const [detailId, setDetailId] = useState(null);
  const [details, setDetails] = useState(null);
  const [detailLoading, setDetailLoading] = useState(false);
  const [columnPrefs, setColumnPrefs] = useState(loadColumnPrefs);
  const [columnsMenuOpen, setColumnsMenuOpen] = useState(false);
  const [draggingColumn, setDraggingColumn] = useState(null);
  const [certMenu, setCertMenu] = useState(null);
  const [certChoice, setCertChoice] = useState({});
  const columnsBtnRef = useRef(null);
  const columnsMenuRef = useRef(null);

  useEffect(() => {
    localStorage.setItem(COLUMN_STORAGE_KEY, JSON.stringify(columnPrefs));
  }, [columnPrefs]);

  useEffect(() => {
    if (!columnsMenuOpen) return undefined;
    const handleClickOutside = (e) => {
      if (
        !columnsMenuRef.current?.contains(e.target) &&
        !columnsBtnRef.current?.contains(e.target)
      ) {
        setColumnsMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [columnsMenuOpen]);

  const moreActionsRef = useRef(null);
  const detailRequestRef = useRef(0);
  const dateMenuRef = useRef(null);
  const limitSelectRef = useRef(null);
  const requestIdRef = useRef(0);
  const isFirstDateRun = useRef(true);
  const latest = useRef({});
  // latest.current = { filters, sel, price, carat, depth, table, startdate, enddate, limit };
  latest.current = { filters, sel, price, carat, depth, table, startdate, enddate, limit, datelable };

  const buildPayload = (skipCount, overrides = {}) => {
    const s = { ...latest.current, ...overrides };
    const f = s.filters || {};
    const payload = {
      limit: s.limit,
      skip: skipCount,
      CUT: pickSelected(s.sel.cut, idsOf(f.Cut)),
      Clarity: pickSelected(s.sel.clarity, idsOf(f.Clarity)),
      Stonecolor: pickSelected(s.sel.color, idsOf(f.StoneColor)),
      Polish: pickSelected(s.sel.polish, idsOf(f.Polish)),
      Symmetry: pickSelected(s.sel.symmetry, idsOf(f.Symmetry)),
      fluorescence: pickSelected(s.sel.fluorescence, idsOf(f.Fluorescence)),
      Lbs: pickSelected(s.sel.lab, f.Lbs || []),
      Status: pickSelected(s.sel.status, f.Status || []).map(Number),
      Location: pickSelected(s.sel.location, idsOf(f.Location)),
      Shape: pickSelected(s.sel.shape, idsOf(f.Shape)),
      Price: [{ min: s.price[0], max: s.price[1] }],
      Carat: [{ min: s.carat[0], max: s.carat[1] }],
      Depth: [{ min: s.depth[0], max: s.depth[1] }],
      Table: [{ min: s.table[0], max: s.table[1] }],
    };
    // if (s.datelable !== 'Show All') {
    if (s.datelable === 'Show All') {
      const withoutTransit = payload.Status.filter((v) => v !== TRANSIT_STATUS);
      payload.Status = withoutTransit.length
        ? withoutTransit
        : (f.Status || []).map(Number).filter((v) => v !== TRANSIT_STATUS);
    }
    if (s.startdate && s.enddate) {
      // payload.start_date = s.startdate;
      // payload.end_date = s.enddate;
      payload.start_date = toApiDate(s.startdate);
      payload.end_date = toApiDate(s.enddate);
    }
    return payload;
  };

  const fetchList = async (skipCount = 0, overrides = {}) => {
    if (!(overrides.filters || latest.current.filters)) return;
    const requestId = ++requestIdRef.current;
    try {
      const res = await _Api(
        buildPayload(skipCount, overrides),
        `api/v1/Inventory/diamond/getList`,
      );
      if (requestId !== requestIdRef.current) return;
      if (res?.code === 200) {
        setItems(res.data || []);
        setTotalresult(Number(res.totalResult) || 0);
        setSkip(skipCount);
        setStats({
          freeStock: res?.freeStock,
          saleOrder: res?.saleOrder,
          reserve:
            res?.reserve ??
            res?.reserveCount ??
            res?.totalReserve ??
            (res.data || []).filter((d) => Number(d?.Status) === 2).length,
          reorderQuantity: res?.reorderQuantity,
        });
      }
    } catch (err) {
      console.log(err, 'err');
    }
  };

  const loadFilters = async () => {
    try {
      const res = await _Api({}, `api/v1/Inventory/diamond/getFilters`);
      if (res?.code === 200) {
        const d = res.data || {};
        const next = {
          filters: d,
          sel: EMPTY_SELECTION,
          price: toRange(d.Price),
          carat: toRange(d.Carat),
          depth: toRange(d.Depth),
          table: toRange(d.Table),
        };
        setFilters(d);
        setSel(EMPTY_SELECTION);
        setPrice(next.price);
        setCarat(next.carat);
        setDepth(next.depth);
        setTable(next.table);
        setComparison([]);
        setSearchText('');
        fetchList(0, next);
      }
    } catch (err) {
      console.log(err, 'err');
    }
  };

  useEffect(() => {
    loadFilters();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (isFirstDateRun.current) {
      isFirstDateRun.current = false;
      return;
    }
    if (startdate && !enddate) return;
    fetchList(0);
    // eslint-disable-next-line
  }, [startdate, enddate]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (moreActionsRef.current && !moreActionsRef.current.contains(event.target)) {
        setMoreActionsOpen(false);
      }
      if (dateMenuRef.current && !dateMenuRef.current.contains(event.target)) {
        setDateMenuOpen(false);
        setCustomRangeOpen(false);
      }
      if (
        limitSelectRef.current &&
        !limitSelectRef.current.contains(event.target) &&
        !event.target.closest?.('.ds-limit__menu')
      ) {
        setLimitMenuOpen(false);
      }
      if (!event.target.closest?.('.ds-cert-pop') && !event.target.closest?.('.ds-cert-btn')) {
        setCertMenu(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleSelection = (key, value) => {
    const current = latest.current.sel[key] || [];
    const nextList = current.includes(value)
      ? current.filter((v) => v !== value)
      : [...current, value];
    const nextSel = { ...latest.current.sel, [key]: nextList };
    setSel(nextSel);
    fetchList(0, { sel: nextSel });
  };

  const rangeSetters = { price: setPrice, carat: setCarat, depth: setDepth, table: setTable };

  const commitRange = (key, value) => {
    const bounds = toRange(
      { price: filters?.Price, carat: filters?.Carat, depth: filters?.Depth, table: filters?.Table }[key],
    );
    const clamp = (n) => Math.min(Math.max(Number(n) || 0, bounds[0]), bounds[1]);
    const next = [clamp(value[0]), clamp(value[1])].sort((a, b) => a - b);
    rangeSetters[key](next);
    fetchList(0, { [key]: next });
  };

  const totalPages = Math.max(1, Math.ceil(Number(totalresult) / limit));
  const currentPage = Math.floor(skip / limit) + 1;

  const goToPage = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages || pageNumber === currentPage) return;
    fetchList((pageNumber - 1) * limit);
    resultsRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const changeLimit = (nextLimit) => {
    setLimit(nextLimit);
    fetchList(0, { limit: nextLimit });
  };

  const changeDates = (lable) => {
    const today = new Date();
    let start = null;
    let end = null;
    if (lable === 'Today') {
      start = new Date();
      end = new Date();
    } else if (lable === 'Yesterday') {
      start = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
      end = start;
    } else if (lable === '7days') {
      start = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7);
      end = new Date();
    } else if (lable === '30days') {
      start = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 30);
      end = new Date();
    } else if (lable === 'ThisMonth') {
      start = new Date(today.getFullYear(), today.getMonth(), 1);
      end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    } else if (lable === 'LastMonth') {
      start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
      end = new Date(today.getFullYear(), today.getMonth(), 0);
    } else if (lable === 'ThisYear') {
      start = new Date(today.getFullYear(), 0, 1);
      end = new Date(today.getFullYear(), 11, 31);
    } else if (lable === 'Show All') {
      // start = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());
      // end = new Date();
      start = null;
      end = null;
    }
    setStartdate(start);
    setEnddate(end);
    setDatelable(lable);
    setDateMenuOpen(false);
  };

  const syncDraft = (start, end) => {
    setDraftStart(start);
    setDraftEnd(end);
    setStartText(formatInputDate(start));
    setEndText(formatInputDate(end));
  };

  const toggleDateMenu = () => {
    if (!dateMenuOpen) syncDraft(startdate, enddate);
    setDateMenuOpen((o) => !o);
  };

  const applyCustomRange = (start, end) => {
    const [from, to] = start <= end ? [start, end] : [end, start];
    setStartdate(from);
    setEnddate(to);
    setDatelable('Custom Range');
    setDateMenuOpen(false);
  };

  const commitTypedDate = (which) => {
    const parsed = parseInputDate(which === 'start' ? startText : endText);
    if (!parsed) {
      syncDraft(draftStart, draftEnd);
      return;
    }
    const nextStart = which === 'start' ? parsed : draftStart;
    const nextEnd = which === 'end' ? parsed : draftEnd;
    syncDraft(nextStart, nextEnd);
    if (nextStart && nextEnd) applyCustomRange(nextStart, nextEnd);
  };

  const readExcel = async () => {
    if (!importfile) {
      error(t('Choose file!'));
      return;
    }
    try {
      const formData = new FormData();
      formData.append('file', importfile);
      formData.append('type', 'DiamondImport');
      const res = await Api_form(formData, `api/v1/Inventory/diamond/uploadDiamondxls`);
      if (res.code === 200) {
        success(
          t('File Sucessfully Uploaded and Backend Process have  Started Now,Please wait!!'),
        );
        setImportfile(null);
        loadFilters();
      } else {
        error(
          res?.message ||
          res?.msg ||
          res?.errors?.[0]?.msg ||
          t('Please Wait or try again later!!'),
        );
      }
    } catch (err) {
      console.log(err, 'err');
    }
  };

  // const SampleExcel = async () => {
  //   try {
  //     const res = await _Api({}, `api/v1/Inventory/diamond/DiamondSamplexls`);
  //     if (res.code === 200) {
  //       const exportLinkElement = document.createElement('a');
  //       exportLinkElement.hidden = true;
  //       exportLinkElement.download = 'Daimond.xlsx';
  //       exportLinkElement.href = res.data;
  //       exportLinkElement.text = 'downloading...';
  //       document.body.appendChild(exportLinkElement);
  //       exportLinkElement.click();
  //       exportLinkElement.remove();
  //     }
  //   } catch (err) {
  //     console.log(err, 'err');
  //   }
  // };


   
  const SampleExcel = async (format = diamondSampleFormat) => {
    const GetloadingID = loading();
    try {
      const exportFormat =
        String(format).toLowerCase() === 'csv' ? 'csv' : 'xlsx';
      const res = await _Api(
        { format: exportFormat },
        `api/v1/Inventory/diamond/DiamondSamplexls`,
      );
      const url = res?.filexlsx || res?.data;
      if (res?.code === 200 && url) {
        const a = document.createElement('a');
        a.hidden = true;
        a.href = url;
        a.download = `Diamond_Sample.${exportFormat}`;
        a.target = '_blank';
        document.body.appendChild(a);
        a.click();
        a.remove();
        Updateloading(
          t,
          GetloadingID,
          res?.message || t('Sample template downloaded'),
        );
      } else {
        Updateloading(
          t,
          GetloadingID,
          res?.message || t('Could not download sample template'),
          'error',
        );
      }
    } catch (err) {
      console.log(err, 'err');
      Updateloading(t, GetloadingID, t('Could not download sample template'), 'error');
    }
  };

  const printPayload = () => {
    const payload = buildPayload(skip);
    return { ...payload, status: payload.Status };
  };

  const getsharediamondsearch = async () => {
    setShareloader(true);
    try {
      const res = await _Api(printPayload(), `api/v1/Inventory/inventory/print/diamondSearch`);
      if (res.code === 200) {
        setSocialurl(res?.link);
      }
    } catch (err) {
      console.log(err, 'err');
    }
    setShareloader(false);
  };

  const getprintdiamondsearch = async () => {
    const GetloadingID = loading();
    try {
      const res = await _Api(printPayload(), `api/v1/Inventory/inventory/print/diamondSearch`);
      if (res.code === 200) {
        setTimeout(() => {
          const exportLinkElement = document.createElement('a');
          exportLinkElement.hidden = true;
          exportLinkElement.download = res?.name ? res?.name : 'report.pdf';
          exportLinkElement.href = res?.link;
          exportLinkElement.text = 'downloading...';
          exportLinkElement.setAttribute('target', '_blank');
          document.body.appendChild(exportLinkElement);
          exportLinkElement.click();
          exportLinkElement.remove();
          Updateloading(t, GetloadingID, t('download successfully'));
        }, 50);
        setSocialurl(res?.link);
      } else {
        Updateloading(t, GetloadingID, res?.message ? res?.message : res?.errors, 'error');
      }
    } catch (err) {
      console.log(err, 'err');
      Updateloading(t, GetloadingID, err, t('error'));
    }
  };

  const callexportrequest = async (format = diamondExportFormat) => {
    try {
      const res = await _Api(
        { type: 'DiamondExport', format: format || 'xlsx' },
        `api/v1/Inventory/diamond/downloadDiamondxls`,
      );
      if (res.code === 200) {
        success(
          t(res?.message || 'Export started. Download will be available in Notifications.'),
        );
      } else {
        error(res?.message || t('Please Wait or try again later!!'));
      }
    } catch (err) {
      error(t('Please Wait or try again later!!'));
      console.log(err, 'err');
    }
  };

  const isStock = (item) => Number(item?.Status) === 1;

  const deleteDiamonds = async () => {
    const ids = comparison.filter(isStock).map((c) => c._id);
    if (!ids.length) return;
    const loadingId = loading();
    try {
      const res = await _Api({ ids }, `api/v1/Inventory/diamond/deleteDiamond`);
      if (res?.code === 200) {
        Updateloading(t, loadingId, t(res?.message || 'Diamond deleted successfully'));
        setComparison([]);
        if (ids.includes(detailId)) closeDetail();
        fetchList(skip);
      } else {
        Updateloading(
          t,
          loadingId,
          res?.message || res?.errors || t('Please Wait or try again later!!'),
          'error',
        );
      }
    } catch (err) {
      console.log(err, 'err');
      Updateloading(t, loadingId, t('Please Wait or try again later!!'), 'error');
    }
  };

  const isDeallocatable = (item) => [2, 3].includes(Number(item?.Status));

  const selectionGroup = (item) =>
    isStock(item) ? 'stock' : isDeallocatable(item) ? 'deallocate' : 'other';

  const deallocateDiamonds = async (type, comment = '') => {
    const ids = comparison.filter(isDeallocatable).map((c) => c._id);
    if (!ids.length) return;
    const loadingId = loading();
    try {
      // const res = await _Api({ ids, type }, `api/v1/Inventory/diamond/deallocation`);
      const res = await _Api({ ids, type, comment }, `api/v1/Inventory/diamond/deallocation`);
      if (res?.code === 200) {
        Updateloading(t, loadingId, t(res?.message || 'Diamond deallocated successfully'));
        setComparison([]);
        if (ids.includes(detailId)) openDetail({ _id: detailId });
        fetchList(skip);
      } else {
        Updateloading(
          t,
          loadingId,
          res?.message || res?.errors || t('Please Wait or try again later!!'),
          'error',
        );
      }
    } catch (err) {
      console.log(err, 'err');
      Updateloading(t, loadingId, t('Please Wait or try again later!!'), 'error');
    }
  };

  const isSelected = (item) => comparison.some((c) => c._id === item?._id);
  const hasStockSelected = comparison.some(isStock);
  const hasDeallocatableSelected = comparison.some(isDeallocatable);
  // const canSelect = (item) =>
  //   isSelected(item) || !comparison.length || isStock(item) === hasStockSelected;
  const canSelect = (item) =>
    isSelected(item) ||
    !comparison.length ||
    selectionGroup(item) === selectionGroup(comparison[0]);

  const toggleCompare = (item) => {
    // if (!isStock(item)) return;
    if (!canSelect(item)) return;
    setComparison((prev) =>
      prev.some((c) => c._id === item._id)
        ? prev.filter((c) => c._id !== item._id)
        : [...prev, item],
    );
  };

  const stockItemsOf = (list) => (list || []).filter(isStock);
  const allStockSelected = (list) => {
    const stock = stockItemsOf(list);
    return stock.length > 0 && stock.every(isSelected);
  };
  const canSelectAllStock = (list) =>
    stockItemsOf(list).length > 0 && (!comparison.length || hasStockSelected);

  const toggleSelectAllStock = (list) => {
    const stock = stockItemsOf(list);
    if (!stock.length) return;
    if (allStockSelected(list)) {
      const ids = new Set(stock.map((s) => s._id));
      setComparison((prev) => prev.filter((c) => !ids.has(c._id)));
      return;
    }
    if (!canSelectAllStock(list)) return;
    setComparison((prev) => {
      const ids = new Set(prev.map((c) => c._id));
      return [...prev, ...stock.filter((s) => !ids.has(s._id))];
    });
  };

  const shapeNameByLogo = useMemo(() => {
    const map = {};
    (filters?.Shape || []).forEach((s) => {
      if (s?.logo) map[s.logo] = s.name;
    });
    return map;
  }, [filters]);

  const shapeName = (item) => item?.ShapeName || shapeNameByLogo[item?.Shape] || '';

  const visibleItems = useMemo(() => {
    const q = searchText.trim().toLowerCase();
    if (!q) return items || [];
    return (items || []).filter((item) =>
      [
        item?.Carat,
        item?.Colour,
        item?.Clarity,
        item?.Cut,
        item?.Certification,
        item?.Location,
        item?.Price,
        shapeNameByLogo[item?.Shape],
      ]
        .filter((v) => v !== undefined && v !== null)
        .some((v) => String(v).toLowerCase().includes(q)),
    );
  }, [items, searchText, shapeNameByLogo]);

  const dateButtonLabel =
    startdate && enddate
      ? `${formatRangeDate(startdate)} – ${formatRangeDate(enddate)}`
      : t('Show All');

  const presetLabel = OLD_DATE_PRESETS.find(([value]) => value === datelable)?.[1];
  // const dateOldLabel =
  //   !startdate || !enddate
  //     ? t('Show All')
  //     : datelable === 'Custom Range' || !presetLabel
  //       ? dateButtonLabel
  //       : t(presetLabel);
  const dateOldLabel = !startdate || !enddate || !presetLabel ? t('Show All') : t(presetLabel);

  const statCards = [
    {
      label: 'Free Stock',
      value: stats.freeStock ?? totalresult,
      icon:<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M32.3875 19.1562L24.0001 23.9987L15.6094 19.1484" stroke="#7CC7FA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M24 24V33" stroke="#7CC7FA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M23.0001 14.5765C23.6189 14.2193 24.3813 14.2193 25.0001 14.5765L31.6604 18.4218C32.2792 18.7791 32.6604 19.4394 32.6604 20.1539V27.8445C32.6604 28.559 32.2792 29.2193 31.6604 29.5766L25.0001 33.4218C24.3813 33.7791 23.6189 33.7791 23.0001 33.4218L16.3398 29.5766C15.721 29.2193 15.3398 28.559 15.3398 27.8445V20.1539C15.3398 19.4394 15.721 18.7791 16.3398 18.4218L23.0001 14.5765Z" stroke="#7CC7FA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M20.5 16.5L28 21" stroke="#7CC7FA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      ,
      tone: 'blue',
    },
    {
      label: 'Reserve',
      // value: stats.saleOrder ?? 0,
      value: stats.reserve ?? 0,
      icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.5 15.0275C5.5 13.023 6.1235 11.3525 7.3705 10.0161C8.61751 8.67203 10.1728 8 12.0364 8C13.8445 8 15.3721 8.67971 16.6191 10.0391C17.873 11.3986 18.5 13.0614 18.5 15.0275C18.5 17.0321 17.8696 18.7256 16.6087 20.1081C15.3479 21.4906 13.8064 22.1818 11.9844 22.1818C10.1693 22.1818 8.63483 21.4906 7.3809 20.1081C6.12697 18.7256 5.5 17.0321 5.5 15.0275ZM7.3705 15.0506C7.3705 17.0244 7.7931 18.622 8.63829 19.8431C9.48348 21.0566 10.5919 21.6634 11.9636 21.6634C13.3492 21.6634 14.4715 21.0413 15.3305 19.7971C16.1965 18.5528 16.6295 17.0014 16.6295 15.1428C16.6295 13.1459 16.2069 11.5445 15.3617 10.3387C14.5165 9.12518 13.4219 8.51843 12.0779 8.51843C10.6508 8.51843 9.50773 9.11365 8.64868 10.3041C7.79656 11.4946 7.3705 13.0767 7.3705 15.0506Z" fill="#FE918F"/>
      <path d="M11.9176 1.5L12.6852 6.81818H11.15L11.9176 1.5Z" fill="#FE918F"/>
      <path d="M17.022 2.89531L15.1768 7.68466L13.331 6.8003L17.022 2.89531Z" fill="#FE918F"/>
      <path d="M6.81395 2.89531L8.65909 7.68466L10.5049 6.8003L6.81395 2.89531Z" fill="#FE918F"/>
      </svg>
      ,
      tone: 'red',
    },
    {
      label: 'Locations',
      value: filters?.Location?.length ?? 0,
      icon: <PlaceOutlinedIcon fontSize="medium"  />,
      tone: 'teal',
    },
    {
      label: 'Reorder Quantity',
      value: stats.reorderQuantity ?? 0,
      icon: <RefreshIcon fontSize="medium" />,
      tone: 'blue',
    },
  ];

  const renderChips = (key, list, getValue, getLabel) => (
    <div className="ds-chips">
      {(list || []).map((option, index) => {
        const value = getValue(option);
        const isActive = sel[key].includes(value);
        return (
          <button
            key={`${key}-${value}-${index}`}
            type="button"
            className={`ds-chip ${isActive ? 'active' : ''}`}
            onClick={() => toggleSelection(key, value)}
          >
            {getLabel(option)}
          </button>
        );
      })}
    </div>
  );

  const renderRange = (key, label, value, bounds, unit, step = 1) => (
    <div className="ds-filter-block">
      <h6 className="ds-filter-title">{t(label)}</h6>
      <div className="ds-range">
        <div className="ds-range-inputs">
          {[0, 1].map((i) => (
            <label className="ds-range-input" key={i}>
              <input
                type="number"
                step={step}
                value={value[i]}
                onChange={(e) => {
                  const next = [...value];
                  next[i] = e.target.value;
                  rangeSetters[key](next);
                }}
                onBlur={() => commitRange(key, value)}
                onKeyDown={(e) => e.key === 'Enter' && e.currentTarget.blur()}
              />
              <span>{unit}</span>
            </label>
          ))}
        </div>
        <Slider
          range
          min={bounds[0]}
          max={bounds[1]}
          step={step}
          value={value.map(Number)}
          onChange={rangeSetters[key]}
          onAfterChange={(v) => fetchList(0, { [key]: v })}
        />
      </div>
    </div>
  );

  const renderStatusBadge = (item, variant = '') => {
    const meta = STATUS_META[item?.Status];
    if (!meta) return null;
    const tooltip = item?.reserveDate
      ? `${item?.customer || ''} ${formatDate(item?.reserveDate)}`.trim()
      : t(meta.label);
    return (
      <span className={`ds-status ${meta.className} ${variant}`.trim()} title={tooltip}>
        {t(meta.label)}
      </span>
    );
  };

  const STATUS_DOT_CLASS = {
    1: 'status-yellow light-blue',
    2: 'status-yellow light-yellow-bg',
    3: 'status-yellow bg-danger',
    4: 'status-gray-tab light-gray-bg',
  };

  // const statusCustomerOf = (item) => {
  //   const c = item?.customer ?? item?.Customer ?? item?.customer_name ?? item?.customerName;
  //   if (c && typeof c === 'object') return c.name || c.Name || c.customer_name || c.fullName || '';
  //   return c || '';
  // };
  //
  // const statusDateOf = (item) =>
  //   item?.reserveDate || item?.soldDate || item?.SoldDate || item?.transitDate || item?.orderDate || '';
  const statusCustomerOf = (item) => {
    const c =
      item?.customer ||
      item?.Customer ||
      item?.customer_name ||
      item?.Customer_name ||
      item?.customerName ||
      item?.CustomerName ||
      item?.reserveBy ||
      item?.reservedBy;
    if (c && typeof c === 'object') return c.name || c.Name || c.customer_name || c.fullName || '';
    return c || '';
  };

  const statusDateOf = (item) =>
    item?.reserveDate ||
    item?.ReserveDate ||
    item?.reserve_date ||
    item?.soldDate ||
    item?.SoldDate ||
    item?.sold_date ||
    item?.orderDate ||
    item?.order_date ||
    item?.deliveryDate ||
    item?.delivery_date ||
    item?.transitDate ||
    '';

  const renderStatusDot = (item) => {
    const status = Number(item?.Status);
    const dotClass = STATUS_DOT_CLASS[status] || 'status-color bg-main-green';
    let tooltip = null;
    if (item?.reserveDate) {
      tooltip = (
        <>
          {item?.customer}
          <br />
          {formatDate(item?.reserveDate)}
        </>
      );
    } else if (status === 1) {
      tooltip = t('Stock');
    }
    //  else if (status === 3) {
    //   tooltip = t('Custom Order');
    // }
    //  else if (status === 4) {
    //   tooltip = t('Transit');
    // }
    return (
      <div className={`${dotClass} tooltip-area-up ds-status-dot`}>
        {tooltip && <span className="tooltip-area-up-text">{tooltip}</span>}
      </div>
    );
  };

  // eslint-disable-next-line no-unused-vars
  const renderStatusDotOld = (item) => {
    const status = Number(item?.Status);
    const dotClass = STATUS_DOT_CLASS[status] || 'status-color bg-main-green';
    let tooltip = null;
    if (item?.reserveDate) {
      tooltip = (
        <>
          {item?.customer}
          <br />
          {formatDate(item?.reserveDate)}
        </>
      );
    } else if (status === 1) {
      tooltip = t('Stock');
    }
    //  else if (status === 3) {
    //   tooltip = t('Custom Order');
    // }
    //  else if (status === 4) {
    //   tooltip = t('Transit');
    // }
    return (
      <div className={`${dotClass} tooltip-area-up ds-status-dot`}>
        {tooltip && <span className="tooltip-area-up-text">{tooltip}</span>}
      </div>
    );
  };

  const isDetailDisabled = (item) => [3, 4].includes(item?.Status);

  const openDetail = async (item) => {
    if (!item?._id || isDetailDisabled(item)) return;
    const requestId = ++detailRequestRef.current;
    setDetailId(item._id);
    setDetails(null);
    setDetailLoading(true);
    try {
      const res = await _Api({ id: item._id }, `api/v1/Inventory/diamond/getDetails`);
      if (requestId !== detailRequestRef.current) return;
      if (res?.code === 200) setDetails(res.data || null);
    } catch (err) {
      console.log(err, 'err');
    } finally {
      if (requestId === detailRequestRef.current) setDetailLoading(false);
    }
  };

  const location = useLocation();
  const navigate = useNavigate();
  const openDiamondId = location.state?.openDiamondId;

  useEffect(() => {
    if (!openDiamondId) return;
    openDetail({ _id: openDiamondId });
    navigate(location.pathname, { replace: true, state: null });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openDiamondId]);

  const closeDetail = () => {
    detailRequestRef.current += 1;
    setDetailId(null);
    setDetails(null);
    setDetailLoading(false);
  };

  const removeReserve = async () => {
    if (!detailId) return;
    try {
      const res = await _Api({ id: detailId }, `api/v1/Inventory/diamond/removeReserve`);
      if (res?.code === 200) {
        setDetails((d) => (d ? { ...d, Status: 1, reserveDate: '', customer: '' } : d));
        setItems((list) => list.map((i) => (i?._id === detailId ? { ...i, Status: 1 } : i)));
      }
    } catch (err) {
      console.log(err, 'err');
    }
  };

  const renderCard = (item) => {
    const isCompared = comparison.some((c) => c._id === item?._id);
    const name = shapeName(item);
    const title = `${item?.Carat ?? ''} ${t('Carats')} ${name} -${item?.Colour ?? ''} / ${item?.Clarity ?? ''}`;
    const subtitle = [
      `${item?.Carat ?? ''} ${t('Carats')}`,
      `${item?.Colour ?? ''}${t('Colour')}`,
      `${item?.Clarity ?? ''} ${t('Clarity')}${name}`,
      item?.Cut,
    ]
      .filter(Boolean)
      .join(', ');
    return (
      // <div className={`ds-card ${isDetailDisabled(item) ? 'is-disabled' : ''}`} key={item?._id}>
      <div
        className={`ds-card ${isDetailDisabled(item) ? 'is-disabled' : ''} ${canSelect(item) ? '' : 'is-select-locked'}`}
        key={item?._id}
      >
        <label className="ds-card-check" onClick={(e) => e.stopPropagation()}>
          <input
            type="checkbox"
            checked={isCompared}
            // disabled={!isStock(item)}
                  disabled={!canSelect(item)}
            onChange={() => toggleCompare(item)}
          />
          <span />
        </label>
        <div
          className="ds-card-link"
          role="button"
          tabIndex={0}
          onClick={() => openDetail(item)}
          onKeyDown={(e) => e.key === 'Enter' && openDetail(item)}
        >
          <div className="ds-card-img">
            {/* <img
              src={item?.Shape ? item?.Shape : base_assets + 'images/icon/camera_profile.png'}
              alt={name}
            /> */}
            {previewMediaOf(item) ? (
              renderPreviewMedia(previewMediaOf(item), name)
            ) : (
              <img
                src={item?.Shape ? item?.Shape : base_assets + 'images/icon/camera_profile.png'}
                alt={name}
              />
            )}
          </div>
          <div className="ds-card-body">
            <div className="ds-card-head">
              <p className="ds-card-title">{title}</p>
              {/* {renderStatusBadge(item, 'ds-status-grid')} */}
              {/* {renderStatusDot(item)} */}
            </div>
            <p className="ds-card-sub">{subtitle}</p>
            <p className="ds-card-cert">{shownCert(item).number}</p>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <p className="ds-card-price">{item?.Price || '0.00'}</p>
            <div style={{ margin: '7.5px 0px 0px' }}>{renderStatusDot(item)}</div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const certificatesOf = (item) => {
    const raw = item?.Certificates || item?.certificates;
    const list = (Array.isArray(raw) ? raw : [])
      .filter(Boolean)
      .map((c) => ({
        lab: c?.GradedBy || c?.gradedBy || c?.lab || '',
        number: c?.Certification || c?.certification || c?.number || '',
        url: c?.CertificationUrl || c?.certificationUrl || c?.url || '',
        image: c?.image || c?.Image || '',
      }))
      .filter((c) => c.lab || c.number || c.url);
    if (list.length) return list;
    if (item?.Certification || item?.GradedBy || item?.CertificationUrl) {
      return [{
        lab: item?.GradedBy || '',
        number: item?.Certification || '',
        url: item?.CertificationUrl || '',
        image: item?.CertificationImage || item?.CertificateImage || item?.certificate_image || '',
      }];
    }
    return [];
  };

  const shownCert = (item) => {
    const certs = certificatesOf(item);
    return certs[certChoice[item?._id] || 0] || certs[0] || { lab: '', number: '', url: '', image: '' };
  };

  const tableColumns = [
    // { key: 'status', label: 'Status', cell: (item) => renderStatusBadge(item) },
    { key: 'status', label: 'Status', className: 'ds-table-status', cell: (item) => renderStatusDot(item) },
    {
      key: 'shape',
      label: 'Shape',
      className: 'ds-table-shape',
      cell: (item) => (
        <img
          src={item?.Shape ? item?.Shape : base_assets + 'images/icon/camera_profile.png'}
          alt=""
        />
      ),
    },
    // { key: 'category', label: 'Category', cell: (item) => item?.Category_name ?? '' },
    {
      key: 'category',
      label: 'Category',
      className: 'ds-table-category',
      cell: (item) => (
        // <span className="ds-ellipsis">
        //   {item?.Category_name ?? ''}
        // </span>
        <span className="ds-ellipsis">
          {categoryText(item)}
        </span>
      ),
    },
    // { key: 'carat', label: 'Carat', className: 'ds-link', cell: (item) => item?.Carat ?? '' },
    {
      key: 'carat',
      label: 'Carat',
      className: 'ds-link',
      cell: (item) =>
        isDetailDisabled(item) ? (
          item?.Carat ?? ''
        ) : (
          <button
            type="button"
            className="ds-carat-link"
            onClick={(e) => {
              e.stopPropagation();
              openDetail(item);
            }}
          >
            {item?.Carat ?? ''}
          </button>
        ),
    },
    { key: 'colour', label: 'Colour', cell: (item) => item?.Colour ?? '' },
    { key: 'clarity', label: 'Clarity', cell: (item) => item?.Clarity ?? '' },
    { key: 'cut', label: 'Cut', cell: (item) => item?.Cut ?? '' },
    { key: 'polish', label: 'Polish', cell: (item) => item?.Polish ?? '' },
    { key: 'symmetry', label: 'Symmetry', cell: (item) => item?.Symmetry ?? '' },
    {
      key: 'fluorescence',
      label: 'Fluorescence',
      cell: (item) => item?.Fluoresence ?? item?.Fluorescence ?? '',
    },
    { key: 'depth', label: 'Depth', cell: (item) => item?.Depth ?? '' },
    { key: 'table', label: 'Table', cell: (item) => item?.Table ?? '' },
    { key: 'gridle', label: 'Gridle', cell: (item) => item?.Gridle_name ?? '' },
    { key: 'culet', label: 'Culet', cell: (item) => item?.Culet_name ?? '' },
    // {
    //   key: 'measurement',
    //   label: 'Measurements (Dimensions)',
    //   cell: (item) => (item?.Measurement ? `${item?.Measurement} mm` : ''),
    // },
    {
      key: 'measurement',
      label: 'Measurements (Dimensions)',
      style: {
        textWrap: 'wrap',
        whiteSpace: 'normal',
        overflowWrap: 'break-word',
      },
      cell: (item) => (item?.Measurement ? `${item.Measurement} mm` : ''),
    },
    // { key: 'gradedBy', label: 'Graded By', cell: (item) => item?.GradedBy ?? '' },
    { key: 'gradedBy', label: 'Graded By', cell: (item) => shownCert(item).lab },
    {
      key: 'certification',
      label: 'Certification',
      cell: (item) => {
        // return (
        //   <span className="ds-table-cert">
        //     <span className="ds-link">{item?.Certification || ''}</span>
        //     {item?.CertificationUrl && ( ... link ... )}
        //   </span>
        // );
        const certs = certificatesOf(item);
        const cert = shownCert(item);
        const open = certMenu?.id === item?._id;
        return (
          <span className="ds-table-cert">
            {certs.length > 1 ? (
              <button
                type="button"
                className="ds-link ds-cert-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  const rect = e.currentTarget.getBoundingClientRect();
                  setCertMenu(open ? null : { id: item._id, top: rect.bottom + 4, left: rect.left });
                }}
              >
                {cert.number}
              </button>
            ) : (
              <span className="ds-link">{cert.number}</span>
            )}
            {cert.url && (
              <a
                className="ds-link"
                target="_blank"
                rel="noreferrer"
                href={cert.url}
                aria-label={t('Certificate link')}
                onClick={(e) => e.stopPropagation()}
              >
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.3713 7.62868C9.19975 6.45711 7.30025 6.45711 6.12868 7.62868L3.12868 10.6287C1.95711 11.8003 1.95711 13.6997 3.12868 14.8713C4.30025 16.0429 6.19975 16.0429 7.37132 14.8713L8.19749 14.0451M7.62868 10.3713C8.80025 11.5429 10.6997 11.5429 11.8713 10.3713L14.8713 7.37132C16.0429 6.19975 16.0429 4.30025 14.8713 3.12868C13.6997 1.95711 11.8003 1.95711 10.6287 3.12868L9.80397 3.95339" stroke="#606060" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </a>
            )}
            {open && (
              <div className="ds-cert-pop" style={{ top: certMenu.top, left: certMenu.left }}>
                {certs.map((c, index) => (
                  <button
                    key={`${c.lab}-${c.number}-${index}`}
                    type="button"
                    className={index === (certChoice[item._id] || 0) ? 'active' : ''}
                    onClick={(e) => {
                      e.stopPropagation();
                      setCertChoice((prev) => ({ ...prev, [item._id]: index }));
                      setCertMenu(null);
                    }}
                  >
                    {c.lab && <span>{c.lab}</span>}
                    <span>{c.number}</span>
                  </button>
                ))}
              </div>
            )}
          </span>
        );
      },
    },
    { key: 'stockId', label: 'Stock Id', cell: (item) => item?.StockID ?? '' },
    { key: 'price', label: 'Price', className: 'text-end', cell: (item) => formatPrice(item?.Price) },
    { key: 'location', label: 'Location', cell: (item) => item?.Location ?? '' },
    {
      key: 'customJewelry',
      label: 'Custom jewelry',
      cell: (item) => {
        const all = customJewelryText(item);
        const names = customJewelryNames(item);
        const preview = customJewelryPreview(item, 3);
        if (!names.length) return '';
        if (names.length <= 3) {
          return <span className="ds-ellipsis">{preview}</span>;
        }
        return (
          <span className="tooltip-area-up ds-ellipsis" style={{ display: 'inline-block', maxWidth: '100%' }}>
            {preview}
            <span
              className="tooltip-area-up-text"
              style={{
                backgroundColor: '#5CC7C1',
                marginBottom: '5px',
                whiteSpace: 'normal',
                width: '220px',
                textAlign: 'left',
              }}
            >
              {all}
            </span>
          </span>
        );
      },
    },
  ];

  const columnByKey = Object.fromEntries(tableColumns.map((col) => [col.key, col]));
  // const visibleColumns = columnPrefs
  //   .filter((pref) => pref.visible && columnByKey[pref.key])
  //   .map((pref) => columnByKey[pref.key]);
  // const visibleColumns = columnPrefs
  //   .filter((pref) => (pref.visible || isFixedColumn(pref.key)) && columnByKey[pref.key])
  //   .map((pref) => columnByKey[pref.key]);
  // const fixedColumnPrefs = columnPrefs.filter((pref) => isFixedColumn(pref.key));
  const fixedColumnPrefs = FIXED_COLUMN_KEYS.map((key) => ({ key, visible: true }));
  const activeColumnPrefs = columnPrefs.filter((pref) => !isFixedColumn(pref.key));
  const visibleColumns = [
    ...fixedColumnPrefs,
    ...activeColumnPrefs.filter((pref) => pref.visible),
  ]
    .filter((pref) => columnByKey[pref.key])
    .map((pref) => columnByKey[pref.key]);

  // const toggleColumn = (key) =>
  //   setColumnPrefs((prev) => {
  //     const visibleCount = prev.filter((p) => p.visible).length;
  //     return prev.map((p) =>
  //       p.key === key && !(p.visible && visibleCount === 1) ? { ...p, visible: !p.visible } : p,
  //     );
  //   });
  const toggleColumn = (key) => {
    if (isFixedColumn(key)) return;
    setColumnPrefs((prev) => prev.map((p) => (p.key === key ? { ...p, visible: !p.visible } : p)));
  };

  const moveColumn = (fromKey, toKey) => {
    if (!fromKey || fromKey === toKey) return;
    setColumnPrefs((prev) => {
      const from = prev.findIndex((p) => p.key === fromKey);
      const to = prev.findIndex((p) => p.key === toKey);
      if (from === -1 || to === -1) return prev;
      const next = [...prev];
      const [moved] = next.splice(from, 1);
      next.splice(to, 0, moved);
      return next;
    });
  };

  const renderTableRows = (list, isComparison) =>
    list.map((item, key) => (
      <tr
        key={item?._id || key}
        // className={`ds-table-row ${isDetailDisabled(item) ? 'is-disabled' : ''}`}
        className={`ds-table-row ${isDetailDisabled(item) ? 'is-disabled' : ''} ${canSelect(item) ? '' : 'is-select-locked'}`}
        // onClick={() => openDetail(item)}
      >
        <td onClick={(e) => e.stopPropagation()}>
          {isComparison ? (
            <button
              type="button"
              className="ds-icon-btn"
              onClick={() => toggleCompare(item)}
              aria-label={t('Remove')}
            >
              <DeleteOutlineIcon fontSize="small" />
            </button>
          ) : (
            <label className="ds-card-check static">
              <input
                type="checkbox"
                checked={comparison.some((c) => c._id === item?._id)}
                // disabled={!isStock(item)}
                  disabled={!canSelect(item)}
                onChange={() => toggleCompare(item)}
              />
              <span />
            </label>
          )}
        </td>
        <td>{isComparison ? key + 1 : skip + key + 1}</td>
        {visibleColumns.map((col) => (
          <td key={col.key} className={col.className}>
            {col.cell(item)}
          </td>
        ))}
        <td />
      </tr>
    ));

  const renderTable = (list, isComparison = false) => (
    <div className="ds-table-outer">
    <div className="ds-table-wrap">
      <table className="ds-table">
        <thead>
          <tr>
            {/* <th /> */}
            <th>
              {!isComparison && (
                <label
                  className="ds-card-check static"
                  title={t('Select all stock diamonds')}
                  onClick={(e) => e.stopPropagation()}
                >
                  <input
                    type="checkbox"
                    checked={allStockSelected(list)}
                    disabled={!allStockSelected(list) && !canSelectAllStock(list)}
                    onChange={() => toggleSelectAllStock(list)}
                  />
                  <span />
                </label>
              )}
            </th>
            <th>#</th>
            {visibleColumns.map((col) => (
              <th
                key={col.key}
                className={col.className === 'text-end' ? 'text-end' : undefined}
                style={col.style}
              >
                {t(col.label)}
              </th>
            ))}
            <th className="text-center" style={{ cursor: 'pointer',padding:'10px 2px' }}>
              <button
                type="button"
                ref={columnsBtnRef}
                className={`ds-icon-btn plain ds-columns-btn ${columnsMenuOpen ? 'active' : ''}`}
                onClick={() => setColumnsMenuOpen((o) => !o)}
                aria-label={t('Show or hide properties')}
                aria-expanded={columnsMenuOpen}
              >
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.168 11.668H5.83464C4.91416 11.668 4.16797 12.4142 4.16797 13.3346V15.0013C4.16797 15.9218 4.91416 16.668 5.83464 16.668H14.168C15.0884 16.668 15.8346 15.9218 15.8346 15.0013V13.3346C15.8346 12.4142 15.0884 11.668 14.168 11.668Z" stroke="#606060" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12.4987 3.33203H7.4987C6.57822 3.33203 5.83203 4.07822 5.83203 4.9987V6.66536C5.83203 7.58584 6.57822 8.33203 7.4987 8.33203H12.4987C13.4192 8.33203 14.1654 7.58584 14.1654 6.66536V4.9987C14.1654 4.07822 13.4192 3.33203 12.4987 3.33203Z" stroke="#606060" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M18.3346 5.83203H14.168" stroke="#606060" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M5.83203 5.83203H0.832031" stroke="#606060" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M18.332 14.168H15.832" stroke="#606060" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M4.16797 14.168H1.66797" stroke="#606060" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

              </button>
            </th>
          </tr>
        </thead>
        <tbody>
          {list.length > 0 && (
            <tr className="ds-table-total">
              <td colSpan={2}>{t('Total')}</td>
              {visibleColumns.map((col) => (
                <td key={col.key} className={col.key === 'price' ? 'text-end' : undefined}>
                  {col.key === 'price' ? formatPrice(sumPrices(list)) : ''}
                </td>
              ))}
              <td />
            </tr>
          )}
          {renderTableRows(list, isComparison)}
        </tbody>
      </table>
    </div>
    {columnsMenuOpen && (
      <div className="ds-columns-menu" ref={columnsMenuRef}>
        {/* <p className="ds-columns-title">{t('Fixed columns')}</p>
        <label className="ds-columns-item is-fixed">
          <span className="ds-columns-check">
            <input type="checkbox" checked disabled readOnly />
            <span />
          </span>
          {t('Check box')}
        </label> */}
        {/* {fixedColumnPrefs.map((pref) => (
          <label key={pref.key} className="ds-columns-item is-fixed">
            <span className="ds-columns-check">
              <input type="checkbox" checked disabled readOnly />
              <span />
            </span>
            {t(columnByKey[pref.key]?.label)}
          </label>
        ))}
        <hr /> */}
        <p className="ds-columns-title">{t('Active columns')}</p>
        <ul className="ds-columns-list">
          {/* {columnPrefs.map((pref) => ( */}
          {activeColumnPrefs.map((pref) => (
            <li
              key={pref.key}
              className={`ds-columns-item ${draggingColumn === pref.key ? 'is-dragging' : ''}`}
              draggable
              onDragStart={(e) => {
                setDraggingColumn(pref.key);
                e.dataTransfer.effectAllowed = 'move';
              }}
              onDragOver={(e) => {
                e.preventDefault();
                moveColumn(draggingColumn, pref.key);
              }}
              onDragEnd={() => setDraggingColumn(null)}
            >
              <label className="ds-columns-check">
                <input
                  type="checkbox"
                  checked={pref.visible}
                  onChange={() => toggleColumn(pref.key)}
                />
                <span />
              </label>
              <span className="ds-columns-label" onClick={() => toggleColumn(pref.key)}>
                {t(columnByKey[pref.key]?.label)}
              </span>
              <DragIndicatorIcon className="ds-columns-drag" fontSize="small" />
            </li>
          ))}
        </ul>
      </div>
    )}
    </div>
  );

  const priceBounds = toRange(filters?.Price);
  const caratBounds = toRange(filters?.Carat);
  const depthBounds = toRange(filters?.Depth);
  const tableBounds = toRange(filters?.Table);

  const dateFilterEl = (
    <div className="ds-date ds-date-old" ref={dateMenuRef}>
      <button
        type="button"
        className={`ds-date-old-btn ${dateMenuOpen ? 'open' : ''}`}
        onClick={() => {
          setCustomRangeOpen(false);
          toggleDateMenu();
        }}
      >
        {dateOldLabel}
      </button>
      {dateMenuOpen && (
        <div className="ds-date-old-menu">
          <ul className="ds-date-old-list">
            {OLD_DATE_PRESETS.map(([value, label]) => (
              <li
                key={value}
                className={
                  (value === 'Custom Range' ? customRangeOpen || datelable === value : datelable === value)
                    ? 'active'
                    : ''
                }
                onClick={() => {
                  if (value === 'Custom Range') {
                    syncDraft(startdate, enddate);
                    setCustomRangeOpen(true);
                    setDateMenuOpen(false);
                  } else {
                    setCustomRangeOpen(false);
                    changeDates(value);
                  }
                }}
              >
                {t(label)}
              </li>
            ))}
          </ul>
          {/* {customRangeOpen && (
            <div className="ds-date-old-calendar">
              <DatePicker
                inline
                selectsRange
                monthsShown={2}
                startDate={draftStart}
                endDate={draftEnd}
                openToDate={draftStart || new Date()}
                onChange={([start, end]) => {
                  syncDraft(start, end);
                  if (start && end) {
                    applyCustomRange(start, end);
                    setCustomRangeOpen(false);
                  }
                }}
              />
            </div>
          )} */}
        </div>
      )}
      {customRangeOpen && (
        <div className="ds-date-old-calendar">
          <DatePicker
            inline
            selectsRange
            monthsShown={2}
            startDate={draftStart}
            endDate={draftEnd}
            openToDate={draftStart || new Date()}
            formatWeekDay={(name) => name.slice(0, 2)}
            onChange={([start, end]) => {
              syncDraft(start, end);
              if (start && end) {
                applyCustomRange(start, end);
                setCustomRangeOpen(false);
              }
            }}
            renderCustomHeader={({ monthDate, customHeaderCount, decreaseMonth, increaseMonth }) => (
              <div className="ds-date-old-cal-header">
                <button
                  type="button"
                  aria-label={t('Previous month')}
                  onClick={decreaseMonth}
                  style={{ visibility: customHeaderCount === 0 ? 'visible' : 'hidden' }}
                >
                  <ChevronLeftIcon fontSize="small" />
                </button>
                <span>
                  {monthDate.toLocaleDateString('en-US', { month: 'long', year: 'numeric' })}
                </span>
                <button
                  type="button"
                  aria-label={t('Next month')}
                  onClick={increaseMonth}
                  style={{ visibility: customHeaderCount === 1 ? 'visible' : 'hidden' }}
                >
                  <ChevronRightIcon fontSize="small" />
                </button>
              </div>
            )}
          />
        </div>
      )}
    </div>
  );

  /* const dateFilterElNew = (
    <div className="ds-date" ref={dateMenuRef}>
      <button type="button" className="ds-date-btn" onClick={toggleDateMenu}>
        <CalendarMonthOutlinedIcon fontSize="small" />
        <span className="ds-date-container">{dateButtonLabel}</span>
        <KeyboardArrowDownIcon fontSize="small" />
      </button>
      {dateMenuOpen && (
        <div className="ds-date-menu">
          <div className="ds-date-inputs">
            {[
              ['start', startText, setStartText],
              ['end', endText, setEndText],
            ].map(([which, text, setText]) => (
              <label className="ds-date-input" key={which}>
                <input
                  type="text"
                  value={text}
                  placeholder="dd/mm/yyyy"
                  onChange={(e) => setText(e.target.value)}
                  onBlur={() => commitTypedDate(which)}
                  onKeyDown={(e) => e.key === 'Enter' && e.currentTarget.blur()}
                />
                <CalendarMonthOutlinedIcon fontSize="small" />
              </label>
            ))}
          </div>
          <div className="ds-date-body">
            <ul className="ds-date-presets">
              {DATE_PRESETS.map(([value, label]) => (
                <li
                  key={value}
                  className={datelable === value ? 'active' : ''}
                  onClick={() => changeDates(value)}
                >
                  {t(label)}
                </li>
              ))}
            </ul>
            <div className="ds-date-calendar">
              <DatePicker
                inline
                selectsRange
                fixedHeight
                startDate={draftStart}
                endDate={draftEnd}
                openToDate={draftStart || new Date()}
                formatWeekDay={(name) => name.slice(0, 3)}
                onChange={([start, end]) => {
                  syncDraft(start, end);
                  if (start && end) applyCustomRange(start, end);
                }}
                renderCustomHeader={({ date, changeYear, decreaseMonth, increaseMonth }) => (
                  <div className="ds-cal-header">
                    <button type="button" onClick={decreaseMonth} aria-label={t('Previous month')}>
                      <ChevronLeftIcon fontSize="small" />
                    </button>
                    <span className="ds-cal-month">
                      {date.toLocaleDateString('en-GB', { month: 'long' })}
                    </span>
                    <span className="ds-cal-year">
                      {date.getFullYear()}
                      <span className="ds-cal-year-spin">
                        <button
                          type="button"
                          onClick={() => changeYear(date.getFullYear() + 1)}
                          aria-label={t('Next year')}
                        >
                          <KeyboardArrowUpIcon fontSize="inherit" />
                        </button>
                        <button
                          type="button"
                          onClick={() => changeYear(date.getFullYear() - 1)}
                          aria-label={t('Previous year')}
                        >
                          <KeyboardArrowDownIcon fontSize="inherit" />
                        </button>
                      </span>
                    </span>
                    <button type="button" onClick={increaseMonth} aria-label={t('Next month')}>
                      <ChevronRightIcon fontSize="small" />
                    </button>
                  </div>
                )}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  ); */

  const selectionActionsEl = (
    <>
      {hasStockSelected && (
        <button
          type="button"
          className="ds-delete-btn"
          title={t('Delete')}
          aria-label={t('Delete')}
          data-bs-toggle="modal"
          data-bs-target="#delete-listedModal"
          onClick={() => setConfirmAction('delete')}
        >
          {/* <DeleteOutlineIcon fontSize="small" /> */}
          <img src={base_assets + 'images/admin/icons/Delete.png'} alt="" />
        </button>
      )}
      {hasDeallocatableSelected && (
        <button
          type="button"
          className="ds-delete-btn"
          title={t('Deallocate')}
          aria-label={t('Deallocate')}
          data-bs-toggle="modal"
          data-bs-target="#deallcocat-modal"
        >
          <img src={base_assets + 'images/admin/icons/Delete.png'} alt="" />
        </button>
      )}
    </>
  );

  const searchEl = (
    <label className="ds-search">
      <SearchOutlinedIcon fontSize="small" />
      <input
        type="text"
        value={searchText}
        placeholder={t('Search here...')}
        onChange={(e) => setSearchText(e.target.value)}
      />
    </label>
  );

  const detailCert = details
    ? shownCert(
        Array.isArray(details.Certificates) && details.Certificates.length
          ? { ...details, _id: detailId }
          : { ...(items.find((i) => i?._id === detailId) || details), _id: detailId },
      )
    : { lab: '', number: '', url: '', image: '' };

  const detailRows = details
    ? [
      // ['Category', details.Category_name],
      ['Category', categoryText(details)],
      ['Custom jewelry', customJewelryText(details)],
      ['Shape', details.Shape],
      ['Weight', details.Carat],
      ['Color', details.Colour],
      ['Clarity', details.Clarity],
      ['Cut', details.Cut],
      ['Polish', details.Polish],
      ['Origin', details.Origin],
      ['Symmetry', details.Symmetry],
      ['Fluorescence', details.Fluoresence ?? details.Fluorescence],
      ['Depth', details.Depth],
      ['Table', details.Table],
      ['Gridle', details.Gridle],
      ['Culet', details.Culet],
      ['Measurements', details.Measurement],
      // ['Certification', [details.GradedBy, details.Certification].filter(Boolean).join('    ')],
      ['Certification', [detailCert.lab, detailCert.number].filter(Boolean).join('    ')],
      ['Location', details.Location],
    ]
    : [];

  const detailTitle = details
    ? `${details.Carat ?? ''} ${t('Carats')} ${details.Shape ?? ''} -${details.Colour ?? ''} / ${details.Clarity ?? ''}`
    : '';

  const detailDescription = details
    ? details.Description ||
    [
      `${details.Carat ?? ''} ${t('Carats')}`,
      `${details.Colour ?? ''}${t('Colour')}`,
      `${details.Clarity ?? ''} ${t('Clarity')}${details.Shape ?? ''}`,
      details.Cut ? `${details.Cut} ${t('Cut')}` : '',
    ]
      .filter(Boolean)
      .join(', ')
    : '';

  // const detailImage =
  //   details?.image?.[0] ||
  //   items.find((i) => i?._id === detailId)?.Shape ||
  //   base_assets + 'images/icon/camera_profile.png';
  // const imageUrl = (img) => (typeof img === 'string' ? img : img?.url || img?.image || img?.path || '');
  // const detailImages = (Array.isArray(details?.image) ? details.image : [details?.image])
  //   .map(imageUrl)
  //   .filter(Boolean);
  // const detailImage =
  //   imageUrl(details?.DefaultImage) ||
  //   imageUrl(details?.defaultImage) ||
  //   detailImages[Number(details?.DefaultImageIndex) || 0] ||
  //   detailImages[0] ||
  //   (Array.isArray(details?.video) ? details.video : [])
  //     .map(imageUrl)
  //     .find((url) => /\.gif(\?|$)/i.test(url)) ||
  //   items.find((i) => i?._id === detailId)?.Shape ||
  //   base_assets + 'images/icon/camera_profile.png';
  const detailImage =
    previewMediaOf(details) ||
    items.find((i) => i?._id === detailId)?.Shape ||
    base_assets + 'images/icon/camera_profile.png';

  // const certificateImage =
  //   details?.Certificates?.find((c) => c?.image)?.image ||
  //   details?.CertificationImage ||
  //   details?.CertificateImage ||
  //   details?.certificate_image ||
  //   '';
  const certificateImage =
    detailCert.image ||
    details?.Certificates?.find((c) => c?.image)?.image ||
    details?.CertificationImage ||
    details?.CertificateImage ||
    details?.certificate_image ||
    '';

  const renderDetailView = () => (
    <div className="ds-detail-layout">
      <aside className="ds-detail-list">
      <div className="ds-diamonds-list-title" style={{ padding: '0px 16px' }}>{t('Diamonds List')}</div>

        <div className="ds-detail-list-bar">
          <span className="ds-results-count">
            {t('Result')}: {totalresult} {t('row(s)')}
          </span>
          <button
            type="button"
            className="ds-icon-btn plain"
            onClick={() => {
              closeDetail();
              setShowMoreFilters(true);
            }}
          >
            <FilterListIcon fontSize="small" />
          </button>
          {selectionActionsEl}
          {dateFilterEl}
          {searchEl}
        </div>
        <div className="ds-detail-list-scroll">
          {visibleItems.map((item, key) => (
            <div
              key={item?._id || key}
              role="button"
              tabIndex={0}
              // className={`ds-detail-row ${item?._id === detailId ? 'active' : ''} ${isDetailDisabled(item) ? 'is-disabled' : ''}`}
              className={`ds-detail-row ${item?._id === detailId ? 'active' : ''} ${isDetailDisabled(item) ? 'is-disabled' : ''} ${canSelect(item) ? '' : 'is-select-locked'}`}
              onClick={() => openDetail(item)}
              onKeyDown={(e) => e.key === 'Enter' && openDetail(item)}
            >
              <label className="ds-card-check static" onClick={(e) => e.stopPropagation()}>
                <input
                  type="checkbox"
                  checked={comparison.some((c) => c._id === item?._id)}
                  // disabled={!isStock(item)}
                  disabled={!canSelect(item)}
                  onChange={() => toggleCompare(item)}
                />
                <span />
              </label>
              <span className="ds-detail-row-no">{skip + key + 1}</span>
              <img
                className="ds-detail-row-shape"
                src={item?.Shape ? item?.Shape : base_assets + 'images/icon/camera_profile.png'}
                alt=""
              />
              <span className="ds-detail-row-carat">{item?.Carat ?? ''}</span>
              <span className="ds-detail-row-lab">{shownCert(item).lab}</span>
              <span className="ds-detail-row-cert">
                {/* {item?.Certification || ''} */}
                {shownCert(item).number}
                {/* {item?.CertificationUrl && item?._id === detailId && ( */}
                {/* {item?.CertificationUrl &&  ( */}
                {shownCert(item).url && (
                  <a
                    href={shownCert(item).url}
                    target="_blank"
                    rel="noreferrer"
                    onClick={(e) => e.stopPropagation()}
                    aria-label={t('Certificate link')}
                  >
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.3713 7.62868C9.19975 6.45711 7.30025 6.45711 6.12868 7.62868L3.12868 10.6287C1.95711 11.8003 1.95711 13.6997 3.12868 14.8713C4.30025 16.0429 6.19975 16.0429 7.37132 14.8713L8.19749 14.0451M7.62868 10.3713C8.80025 11.5429 10.6997 11.5429 11.8713 10.3713L14.8713 7.37132C16.0429 6.19975 16.0429 4.30025 14.8713 3.12868C13.6997 1.95711 11.8003 1.95711 10.6287 3.12868L9.80397 3.95339" stroke="#606060" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

                  </a>
                )}
              </span>
              <span className="ds-detail-row-location">{item?.Location ?? ''}</span>
              {/* <span className="ds-detail-row-status">{renderStatusBadge(item)}</span> */}
              <span className="ds-detail-row-status">{renderStatusDot(item)}</span>
            </div>
          ))}
          {!visibleItems.length && <p className="ds-empty">{t('No data available')}</p>}
        </div>
        {Number(totalresult) > limit && (
          <div className="ds-pagination compact">
            <Pagination total={totalPages} current={currentPage} pagination={goToPage} />
          </div>
        )}
      </aside>

      <section className="ds-detail-panel">
        <div className="ds-detail-head">
          <button type="button" className="ds-detail-back" onClick={closeDetail}>
            <ArrowForwardIosIcon fontSize="small" />
            {t('Information')}
          </button>
          <div className="ds-detail-actions">
            {details?.Status === 2 && (
              <button
                type="button"
                className="ds-outline-btn"
                data-bs-toggle="modal"
                data-bs-target="#delete-listedModal"
                onClick={() => setConfirmAction('reserve')}
              >
                {t('Remove Reserve')}
              </button>
            )}
            {details?.Status !== 2 && (
              <>
                <button
                  type="button"
                  className="ds-detail-edit-btn"
                  aria-label={t('Edit')}
                  // disabled={!details}
                  disabled={details?.Status !== 1}
                  onClick={() =>
                    navigate('/app/inventory/createDiamond', { state: { editDiamondId: detailId } })
                  }
                >
                  <EditOutlinedIcon fontSize="small" />
                </button>
                <Link
                  className={`ds-primary-btn ${details?.Status === 1 ? '' : 'is-disabled'}`}
                  to="/app/inventory/createReserve"
                  state={{ daimondid: detailId }}
                >
                  {t('Reserve')}
                </Link>
              </>
            )}
          </div>
        </div>

        {detailLoading && !details ? (
          <p className="ds-empty">{t('Loading...')}</p>
        ) : details ? (
          <div className="ds-detail-body">
            <div className="ds-detail-summary">
              <div className="ds-detail-info">
                <h6 className="ds-detail-title">{detailTitle}</h6>
                <dl className="ds-detail-dl">
                  <dt>{t('Product ID')}</dt>
                  <dd>{details.ProductID ?? ''}</dd>
                  <dt>{t('Stock Id')}</dt>
                  <dd className="ds-detail-inline">
                    {details.StockID ?? ''}
                    {/* {renderStatusBadge(details)} */}
                    <div style={{ marginLeft: '0px' }}>{renderStatusDot(details)}</div>
                    {/* {renderStatusDot(details)} */}
                  </dd>
                  <dt>{t('Price')}</dt>
                  <dd>{details.Price ?? ''}</dd>
                  {/* <dt>{t('Report')}</dt> */}
                  <dt className="ds-detail-report">
                    {t('Report')}
                    {certificateImage && (
                      <a
                        className="ds-detail-cert-img"
                        href={certificateImage}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img src={certificateImage} alt={t('Certificate')} />
                      </a>
                    )}
                  </dt>
                  <dd className="ds-detail-inline">
                    {/* {details.CertificationUrl ? (
                      <a className="ds-link" href={details.CertificationUrl} target="_blank" rel="noreferrer">
                        {details.Certification}
                      </a>
                    ) : (
                      <span className="ds-link">{details.Certification ?? ''}</span>
                    )} */}
                    {detailCert.url ? (
                      <a className="ds-link" href={detailCert.url} target="_blank" rel="noreferrer">
                        {detailCert.number}
                      </a>
                    ) : (
                      <span className="ds-link">{detailCert.number}</span>
                    )}
                    {detailCert.url && <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.3713 7.62868C9.19975 6.45711 7.30025 6.45711 6.12868 7.62868L3.12868 10.6287C1.95711 11.8003 1.95711 13.6997 3.12868 14.8713C4.30025 16.0429 6.19975 16.0429 7.37132 14.8713L8.19749 14.0451M7.62868 10.3713C8.80025 11.5429 10.6997 11.5429 11.8713 10.3713L14.8713 7.37132C16.0429 6.19975 16.0429 4.30025 14.8713 3.12868C13.6997 1.95711 11.8003 1.95711 10.6287 3.12868L9.80397 3.95339" stroke="#606060" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
}
                  </dd>
                  <dt>{t('Description')}</dt>
                  <dd>{detailDescription}</dd>
                </dl>
              </div>
              <div className="ds-detail-image">
                {/* <img src={detailImage} alt={detailTitle} /> */}
                {VIDEO_URL_PATTERN.test(detailImage) ? (
                  renderPreviewMedia(detailImage, detailTitle)
                ) : (
                  <img src={detailImage} alt={detailTitle} />
                )}
              </div>
            </div>

            <h6 className="ds-detail-section">{t('Diamonds details')}</h6>
            <dl className="ds-detail-dl wide">
              {detailRows.map(([label, value]) => (
                <React.Fragment key={label}>
                  <dt>{t(label)}</dt>
                  <dd>{value ?? ''}</dd>
                </React.Fragment>
              ))}
            </dl>
          </div>
        ) : (
          <p className="ds-empty">{t('No data available')}</p>
        )}
      </section>
    </div>
  );

  return (
    <React.Fragment>
      <div className="main-body ds-page">
        <div className="ds-topbar">
          <nav className="ds-breadcrumb">
            <Link to="/app/inventory/myInventory">{t('Inventory')}</Link>
            {/* <span className="ds-breadcrumb-sep">›</span> */}
            <ArrowForwardIosIcon fontSize="small" htmlColor='#BCBCBC' />
            <span className="ds-breadcrumb-current">{t('Diamonds')}</span>
          </nav>
          <div className="ds-topbar-actions">
            <Link className="ds-primary-btn" to="/app/inventory/createDiamond">
              <AddCircleOutlineIcon fontSize="small" />
              {t('Create')}
            </Link>
            {!detailId && (
            <div className="ds-more-actions" ref={moreActionsRef}>
              <button
                type="button"
                className="ds-more-actions-btn"
                onClick={() => setMoreActionsOpen((o) => !o)}
              >
                <MoreVertIcon fontSize="small" />
                {/* {t('More actions')}
                <KeyboardArrowDownIcon fontSize="small" /> */}
              </button>
              {moreActionsOpen && (
                <ul className="ds-menu" onClick={() => setMoreActionsOpen(false)}>
                  {parmissiondatashow?.inventory_diamond_search?.Print && (
                    <li onClick={getprintdiamondsearch}>
                      <PrintOutlinedIcon fontSize="small" />
                      {t('Print')}
                    </li>
                  )}
                  <li data-bs-toggle="modal" data-bs-target="#diamondExportFormatModal">
                    <FileDownloadOutlinedIcon fontSize="small" />
                    {t('Export')}
                  </li>
                  <li data-bs-toggle="modal" data-bs-target="#diamondSampleFormatModal">
                    <FileDownloadOutlinedIcon fontSize="small" />
                    {t('Sample')}
                  </li>
                  <li data-bs-toggle="modal" data-bs-target="#ImportModal">
                    <FileUploadOutlinedIcon fontSize="small" />
                    {t('Import')}
                  </li>
                  <li
                    data-bs-toggle="modal"
                    data-bs-target="#socialModal"
                    onClick={getsharediamondsearch}
                  >
                    <ShareOutlinedIcon fontSize="small" />
                    {t('Share')}
                  </li>
                  <li
                    onMouseDown={(e) => e.stopPropagation()}
                    onClick={() => {
                      setViewMode('table');
                      setColumnsMenuOpen(true);
                    }}
                  >
                    <ViewColumnOutlinedIcon fontSize="small" />
                    {t('column')}
                  </li>
                  <li onClick={() => setShowAnalytics((o) => !o)}>
                    {showAnalytics ? (
                      <VisibilityOffOutlinedIcon fontSize="small" />
                    ) : (
                      <VisibilityOutlinedIcon fontSize="small" />
                    )}
                    {showAnalytics ? t('Hide Analytics') : t('Show Analytics')}
                  </li>
                  <li onClick={loadFilters}>
                    <RestartAltOutlinedIcon fontSize="small" />
                    {t('Reset Filters')}
                  </li>
                </ul>
              )}
            </div>
            )}
          </div>
        </div>

        {detailId ? (
          renderDetailView()
        ) : (
          <>
        {showAnalytics && (
          <div className="ds-stats">
            {statCards.map((card) => (
              <div className="ds-stat-card" key={card.label}>
                <div>
                  <p className="ds-stat-label">{t(card.label)}</p>
                  <p className="ds-stat-value">{card.value}</p>
                </div>
                <span className={`ds-stat-icon tone-${card.tone}`}>{card.icon}</span>
              </div>
            ))}
          </div>
        )}
        <div className="ds-diamonds-list-title">{t('Diamonds List')}</div>
        <section className="ds-filters">
          <div className="ds-filters-grid">
            <div className="ds-filter-block">
              <h6 className="ds-filter-title">{t('Shape')}</h6>
              <div className="ds-shapes">
                {(filters?.Shape || []).map((shape) => (
                  <button
                    type="button"
                    key={shape?._id}
                    className={`ds-shape ${sel.shape.includes(shape?._id) ? 'active' : ''}`}
                    onClick={() => toggleSelection('shape', shape?._id)}
                  >
                    <span className="ds-shape-img">
                      <img src={shape?.logo} alt="" />
                    </span>
                    <span className="ds-shape-name">{shape?.name}</span>
                  </button>
                ))}
              </div>
            </div>

            <div className="ds-filter-col">
              {renderRange('carat', 'Carat', carat, caratBounds, t('Ct'), 0.01)}
              {renderRange('price', 'Price', price, priceBounds, filters?.currency || '', 1)}
            </div>

            <div className="ds-filter-col">
              <div className="ds-filter-block">
                <h6 className="ds-filter-title">{t('Colour')}</h6>
                {renderChips('color', filters?.StoneColor, (o) => o?._id, (o) => o?.code)}
              </div>
              <div className="ds-filter-block">
                <h6 className="ds-filter-title">{t('Clarity')}</h6>
                {renderChips('clarity', filters?.Clarity, (o) => o?._id, (o) => o?.code)}
              </div>
              <div className="ds-filter-block">
                <h6 className="ds-filter-title">{t('Cut')}</h6>
                {renderChips('cut', filters?.Cut, (o) => o?._id, (o) => o?.code)}
              </div>
            </div>
          </div>

          {showMoreFilters && (
            <div className="ds-filters-grid ds-filters-more">
              <div className="ds-filter-col">
                <div className="ds-filter-block">
                  <h6 className="ds-filter-title">{t('Polish')}</h6>
                  {renderChips('polish', filters?.Polish, (o) => o?._id, (o) => o?.code)}
                </div>
                {renderRange('depth', 'Depth', depth, depthBounds, '%', 0.1)}
                <div className="ds-filter-block">
                  <h6 className="ds-filter-title">{t('Location')}</h6>
                  {renderChips('location', filters?.Location, (o) => o?._id, (o) => o?.name)}
                </div>
              </div>
              <div className="ds-filter-col">
                <div className="ds-filter-block">
                  <h6 className="ds-filter-title">{t('Symmetry')}</h6>
                  {renderChips('symmetry', filters?.Symmetry, (o) => o?._id, (o) => o?.code)}
                </div>
                {renderRange('table', 'Table', table, tableBounds, '%', 0.1)}
              </div>
              <div className="ds-filter-col">
                <div className="ds-filter-block">
                  <h6 className="ds-filter-title">{t('Fluorescence')}</h6>
                  {renderChips('fluorescence', filters?.Fluorescence, (o) => o?._id, (o) => o?.code)}
                </div>
                <div className="ds-filter-block">
                  <h6 className="ds-filter-title">{t('Lab')}</h6>
                  {renderChips('lab', filters?.Lbs, (o) => o, (o) => String(o).toUpperCase())}
                </div>
                <div className="ds-filter-block">
                  <h6 className="ds-filter-title">{t('Status')}</h6>
                  {renderChips(
                    'status',
                    [...(filters?.Status || [])].sort((a, b) => a - b),
                    (o) => o,
                    (o) => t(STATUS_META[o]?.label || String(o)),
                  )}
                </div>
              </div>
            </div>
          )}

          <button
            type="button"
            className="ds-more-filters-btn"
            onClick={() => setShowMoreFilters((o) => !o)}
          >
            {showMoreFilters ? (
              <KeyboardArrowUpIcon fontSize="small" />
            ) : (
              <KeyboardArrowDownIcon fontSize="small" />
            )}
            {showMoreFilters ? t('Hide Filters') : t('More Filters')}
          </button>
        </section>

        <div className="ds-results-bar" ref={resultsRef}>
          <div className="ds-results-left">
            <div ref={limitSelectRef}>
              <Select
                className="limit-select short ds-limit-select"
                classNamePrefix="ds-limit"
                options={PAGE_SIZE_OPTIONS}
                value={{ label: limit, value: limit }}
                // onChange={(option) => changeLimit(option.value)}
                onChange={(option) => {
                  setLimitMenuOpen(false);
                  changeLimit(option.value);
                }}
                isSearchable={false}
                menuIsOpen={limitMenuOpen}
                onMenuOpen={() => setLimitMenuOpen(true)}
                onMenuClose={() => setLimitMenuOpen(false)}
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
              />
            </div>
            <span className="ds-results-count">
              {t('Result')}: {totalresult} {t('row(s)')}
            </span>
            <div className="ds-view-toggle">
              <button
                type="button"
                className={viewMode === 'table' ? 'active' : ''}
                onClick={() => setViewMode('table')}
              >
                <TableRowsOutlinedIcon fontSize="small" />
              </button>
              <button
                type="button"
                className={viewMode === 'grid5' ? 'active' : ''}
                onClick={() => setViewMode('grid5')}
              >
                <GridOnOutlinedIcon fontSize="small" />
              </button>
              <button
                type="button"
                className={viewMode === 'grid4' ? 'active' : ''}
                onClick={() => setViewMode('grid4')}
              >
                <WindowOutlinedIcon fontSize="small" />
              </button>
            </div>
            {/* <button
              type="button"
              className={`ds-compare-btn ${activeTab === 'comparison' ? 'active' : ''}`}
              onClick={() =>
                setActiveTab((tab) => (tab === 'comparison' ? 'results' : 'comparison'))
              }
            >
              <CompareArrowsOutlinedIcon fontSize="small" />
              {t('Comparision')} ({comparison.length})
            </button> */}
          </div>

          <div className="ds-results-right">
            {/* {comparison.length > 0 && ( */}
            {/* {hasStockSelected && (
              <button
                type="button"
                className="ds-delete-btn"
                title={t('Delete')}
                aria-label={t('Delete')}
                data-bs-toggle="modal"
                data-bs-target="#delete-listedModal"
                onClick={() => setConfirmAction('delete')}
              >
                <img
                      
                            src={base_assets + "images/admin/icons/Delete.png"} alt="" />
              </button>
            )}
            {hasDeallocatableSelected && (
              <button
                type="button"
                className="ds-delete-btn"
                title={t('Deallocate')}
                aria-label={t('Deallocate')}
                data-bs-toggle="modal"
                data-bs-target="#deallcocat-modal"
              >
                 <img
                      src={base_assets + "images/admin/icons/Delete.png"} alt="" />
              </button>
            )} */}
            {selectionActionsEl}
            {dateFilterEl}
            {searchEl}
          </div>
        </div>

        {activeTab === 'comparison' ? (
          comparison.length ? (
            renderTable(comparison, true)
          ) : (
            <p className="ds-empty">{t('Select diamonds to compare')}</p>
          )
        ) : (
          <>
            {viewMode === 'table' ? (
              renderTable(visibleItems)
            ) : (
              <div className={`ds-grid ${viewMode}`}>
                {visibleItems.map((item) => renderCard(item))}
              </div>
            )}
            {!visibleItems.length && <p className="ds-empty">{t('No data available')}</p>}
            {Number(totalresult) > 0 && (
              <div className="ds-pagination">
                <Pagination total={totalPages} current={currentPage} pagination={goToPage} />
              </div>
            )}
          </>
        )}
          </>
        )}
      </div>

      {/* <DeleteModal statement="Reserve Daimond" handler_delete={removeReserve} /> */}
      <DeallocateModal
        deallcocation_order_close={deallocateDiamonds}
        deallcocation_deallocate={deallocateDiamonds}
      />
      <DeleteModal
        statement={
          // confirmAction === 'delete'
          //   ? `${comparison.filter(isStock).length} ${t(comparison.filter(isStock).length > 1 ? 'Diamonds' : 'Diamond')}`
          //   : 'Reserve Daimond'
            confirmAction === 'delete'
            ? `${t(comparison.filter(isStock).length > 1 ? 'Diamonds' : 'Diamond')}`
            : 'Reserve Daimond'
        }
        handler_delete={confirmAction === 'delete' ? deleteDiamonds : removeReserve}
      />
      <ImportExcelModal
        setImportfile={setImportfile}
        readExcel={readExcel}
        importfile={importfile}
      />
       <div
        className="modal fade common-modal"
        id="diamondSampleFormatModal"
        tabIndex={-1}
        aria-labelledby="diamondSampleFormatModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <img
                className="common-modal-exclamation-img"
                src={base_assets + 'images/icons/exclamation-mark-green.png'}
                alt=""
              />
              <p className="modal-content-text mb-2" id="diamondSampleFormatModalLabel">
                {t('Export format')}
              </p>
              <div className="d-flex justify-content-center gap-3 flex-wrap mb-3">
                <label className="d-flex align-items-center gap-1">
                  <input
                    type="radio"
                    name="diamondSampleFormat"
                    value="xlsx"
                    checked={diamondSampleFormat === 'xlsx'}
                    onChange={() => setDiamondSampleFormat('xlsx')}
                  />
                  {t('Excel (.xlsx)')}
                </label>
                <label className="d-flex align-items-center gap-1">
                  <input
                    type="radio"
                    name="diamondSampleFormat"
                    value="csv"
                    checked={diamondSampleFormat === 'csv'}
                    onChange={() => setDiamondSampleFormat('csv')}
                  />
                  {t('CSV')}
                </label>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn modal-content-yes"
                data-bs-dismiss="modal"
                onClick={() => SampleExcel(diamondSampleFormat)}
              >
                {t('Download')}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade common-modal"
        id="diamondExportFormatModal"
        tabIndex={-1}
        aria-labelledby="diamondExportFormatModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <img
                className="common-modal-exclamation-img"
                src={base_assets + 'images/icons/exclamation-mark-green.png'}
                alt=""
              />
              <p className="modal-content-text mb-2">{t('Export format')}</p>
              <div className="d-flex justify-content-center gap-3 flex-wrap mb-3">
                <label className="d-flex align-items-center gap-1">
                  <input
                    type="radio"
                    name="diamondExportFormat"
                    value="xlsx"
                    checked={diamondExportFormat === 'xlsx'}
                    onChange={() => setDiamondExportFormat('xlsx')}
                  />
                  {t('Excel (.xlsx)')}
                </label>
                <label className="d-flex align-items-center gap-1">
                  <input
                    type="radio"
                    name="diamondExportFormat"
                    value="csv"
                    checked={diamondExportFormat === 'csv'}
                    onChange={() => setDiamondExportFormat('csv')}
                  />
                  {t('CSV')}
                </label>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn modal-content-yes"
                data-bs-dismiss="modal"
                onClick={() => callexportrequest(diamondExportFormat)}
              >
                {t('Export')}
              </button>
            </div>
          </div>
        </div>
      </div>
      <SocialModal shareUrl={socialurl} shareloader={shareloader} />
      <TableColumnModal></TableColumnModal>
    </React.Fragment>
  );
};

export default DiamondSearch;
